export const addresses = [
	{ code: 450000000, parentCode: 0, name: "广西壮族自治区", level: 1 },
	{ code: 450100000, parentCode: 450000000, name: "南宁市", level: 2 },
	{ code: 450200000, parentCode: 450000000, name: "柳州市", level: 2 },
	{ code: 450300000, parentCode: 450000000, name: "桂林市", level: 2 },
	{ code: 450400000, parentCode: 450000000, name: "梧州市", level: 2 },
	{ code: 450500000, parentCode: 450000000, name: "北海市", level: 2 },
	{ code: 450600000, parentCode: 450000000, name: "防城港市", level: 2 },
	{ code: 450700000, parentCode: 450000000, name: "钦州市", level: 2 },
	{ code: 450800000, parentCode: 450000000, name: "贵港市", level: 2 },
	{ code: 450900000, parentCode: 450000000, name: "玉林市", level: 2 },
	{ code: 451000000, parentCode: 450000000, name: "百色市", level: 2 },
	{ code: 451100000, parentCode: 450000000, name: "贺州市", level: 2 },
	{ code: 451200000, parentCode: 450000000, name: "河池市", level: 2 },
	{ code: 451300000, parentCode: 450000000, name: "来宾市", level: 2 },
	{ code: 451400000, parentCode: 450000000, name: "崇左市", level: 2 },
	{ code: 450102000, parentCode: 450100000, name: "兴宁区", level: 3 },
	{ code: 450103000, parentCode: 450100000, name: "青秀区", level: 3 },
	{ code: 450105000, parentCode: 450100000, name: "江南区", level: 3 },
	{ code: 450107000, parentCode: 450100000, name: "西乡塘区", level: 3 },
	{ code: 450108000, parentCode: 450100000, name: "良庆区", level: 3 },
	{ code: 450109000, parentCode: 450100000, name: "邕宁区", level: 3 },
	{ code: 450110000, parentCode: 450100000, name: "武鸣区", level: 3 },
	{ code: 450123000, parentCode: 450100000, name: "隆安县", level: 3 },
	{ code: 450124000, parentCode: 450100000, name: "马山县", level: 3 },
	{ code: 450125000, parentCode: 450100000, name: "上林县", level: 3 },
	{ code: 450126000, parentCode: 450100000, name: "宾阳县", level: 3 },
	{ code: 450181000, parentCode: 450100000, name: "横州市", level: 3 },
	{ code: 450202000, parentCode: 450200000, name: "城中区", level: 3 },
	{ code: 450203000, parentCode: 450200000, name: "鱼峰区", level: 3 },
	{ code: 450204000, parentCode: 450200000, name: "柳南区", level: 3 },
	{ code: 450205000, parentCode: 450200000, name: "柳北区", level: 3 },
	{ code: 450206000, parentCode: 450200000, name: "柳江区", level: 3 },
	{ code: 450222000, parentCode: 450200000, name: "柳城县", level: 3 },
	{ code: 450223000, parentCode: 450200000, name: "鹿寨县", level: 3 },
	{ code: 450224000, parentCode: 450200000, name: "融安县", level: 3 },
	{ code: 450225000, parentCode: 450200000, name: "融水苗族自治县", level: 3 },
	{ code: 450226000, parentCode: 450200000, name: "三江侗族自治县", level: 3 },
	{ code: 450302000, parentCode: 450300000, name: "秀峰区", level: 3 },
	{ code: 450303000, parentCode: 450300000, name: "叠彩区", level: 3 },
	{ code: 450304000, parentCode: 450300000, name: "象山区", level: 3 },
	{ code: 450305000, parentCode: 450300000, name: "七星区", level: 3 },
	{ code: 450311000, parentCode: 450300000, name: "雁山区", level: 3 },
	{ code: 450312000, parentCode: 450300000, name: "临桂区", level: 3 },
	{ code: 450321000, parentCode: 450300000, name: "阳朔县", level: 3 },
	{ code: 450323000, parentCode: 450300000, name: "灵川县", level: 3 },
	{ code: 450324000, parentCode: 450300000, name: "全州县", level: 3 },
	{ code: 450325000, parentCode: 450300000, name: "兴安县", level: 3 },
	{ code: 450326000, parentCode: 450300000, name: "永福县", level: 3 },
	{ code: 450327000, parentCode: 450300000, name: "灌阳县", level: 3 },
	{ code: 450328000, parentCode: 450300000, name: "龙胜各族自治县", level: 3 },
	{ code: 450329000, parentCode: 450300000, name: "资源县", level: 3 },
	{ code: 450330000, parentCode: 450300000, name: "平乐县", level: 3 },
	{ code: 450332000, parentCode: 450300000, name: "恭城瑶族自治县", level: 3 },
	{ code: 450381000, parentCode: 450300000, name: "荔浦市", level: 3 },
	{ code: 450403000, parentCode: 450400000, name: "万秀区", level: 3 },
	{ code: 450405000, parentCode: 450400000, name: "长洲区", level: 3 },
	{ code: 450406000, parentCode: 450400000, name: "龙圩区", level: 3 },
	{ code: 450421000, parentCode: 450400000, name: "苍梧县", level: 3 },
	{ code: 450422000, parentCode: 450400000, name: "藤县", level: 3 },
	{ code: 450423000, parentCode: 450400000, name: "蒙山县", level: 3 },
	{ code: 450481000, parentCode: 450400000, name: "岑溪市", level: 3 },
	{ code: 450502000, parentCode: 450500000, name: "海城区", level: 3 },
	{ code: 450503000, parentCode: 450500000, name: "银海区", level: 3 },
	{ code: 450512000, parentCode: 450500000, name: "铁山港区", level: 3 },
	{ code: 450521000, parentCode: 450500000, name: "合浦县", level: 3 },
	{ code: 450602000, parentCode: 450600000, name: "港口区", level: 3 },
	{ code: 450603000, parentCode: 450600000, name: "防城区", level: 3 },
	{ code: 450621000, parentCode: 450600000, name: "上思县", level: 3 },
	{ code: 450681000, parentCode: 450600000, name: "东兴市", level: 3 },
	{ code: 450702000, parentCode: 450700000, name: "钦南区", level: 3 },
	{ code: 450703000, parentCode: 450700000, name: "钦北区", level: 3 },
	{ code: 450721000, parentCode: 450700000, name: "灵山县", level: 3 },
	{ code: 450722000, parentCode: 450700000, name: "浦北县", level: 3 },
	{ code: 450802000, parentCode: 450800000, name: "港北区", level: 3 },
	{ code: 450803000, parentCode: 450800000, name: "港南区", level: 3 },
	{ code: 450804000, parentCode: 450800000, name: "覃塘区", level: 3 },
	{ code: 450821000, parentCode: 450800000, name: "平南县", level: 3 },
	{ code: 450881000, parentCode: 450800000, name: "桂平市", level: 3 },
	{ code: 450902000, parentCode: 450900000, name: "玉州区", level: 3 },
	{ code: 450903000, parentCode: 450900000, name: "福绵区", level: 3 },
	{ code: 450921000, parentCode: 450900000, name: "容县", level: 3 },
	{ code: 450922000, parentCode: 450900000, name: "陆川县", level: 3 },
	{ code: 450923000, parentCode: 450900000, name: "博白县", level: 3 },
	{ code: 450924000, parentCode: 450900000, name: "兴业县", level: 3 },
	{ code: 450981000, parentCode: 450900000, name: "北流市", level: 3 },
	{ code: 451002000, parentCode: 451000000, name: "右江区", level: 3 },
	{ code: 451003000, parentCode: 451000000, name: "田阳区", level: 3 },
	{ code: 451022000, parentCode: 451000000, name: "田东县", level: 3 },
	{ code: 451024000, parentCode: 451000000, name: "德保县", level: 3 },
	{ code: 451026000, parentCode: 451000000, name: "那坡县", level: 3 },
	{ code: 451027000, parentCode: 451000000, name: "凌云县", level: 3 },
	{ code: 451028000, parentCode: 451000000, name: "乐业县", level: 3 },
	{ code: 451029000, parentCode: 451000000, name: "田林县", level: 3 },
	{ code: 451030000, parentCode: 451000000, name: "西林县", level: 3 },
	{ code: 451031000, parentCode: 451000000, name: "隆林各族自治县", level: 3 },
	{ code: 451081000, parentCode: 451000000, name: "靖西市", level: 3 },
	{ code: 451082000, parentCode: 451000000, name: "平果市", level: 3 },
	{ code: 451102000, parentCode: 451100000, name: "八步区", level: 3 },
	{ code: 451103000, parentCode: 451100000, name: "平桂区", level: 3 },
	{ code: 451121000, parentCode: 451100000, name: "昭平县", level: 3 },
	{ code: 451122000, parentCode: 451100000, name: "钟山县", level: 3 },
	{ code: 451123000, parentCode: 451100000, name: "富川瑶族自治县", level: 3 },
	{ code: 451202000, parentCode: 451200000, name: "金城江区", level: 3 },
	{ code: 451203000, parentCode: 451200000, name: "宜州区", level: 3 },
	{ code: 451221000, parentCode: 451200000, name: "南丹县", level: 3 },
	{ code: 451222000, parentCode: 451200000, name: "天峨县", level: 3 },
	{ code: 451223000, parentCode: 451200000, name: "凤山县", level: 3 },
	{ code: 451224000, parentCode: 451200000, name: "东兰县", level: 3 },
	{ code: 451225000, parentCode: 451200000, name: "罗城仫佬族自治县", level: 3 },
	{ code: 451226000, parentCode: 451200000, name: "环江毛南族自治县", level: 3 },
	{ code: 451227000, parentCode: 451200000, name: "巴马瑶族自治县", level: 3 },
	{ code: 451228000, parentCode: 451200000, name: "都安瑶族自治县", level: 3 },
	{ code: 451229000, parentCode: 451200000, name: "大化瑶族自治县", level: 3 },
	{ code: 451302000, parentCode: 451300000, name: "兴宾区", level: 3 },
	{ code: 451321000, parentCode: 451300000, name: "忻城县", level: 3 },
	{ code: 451322000, parentCode: 451300000, name: "象州县", level: 3 },
	{ code: 451323000, parentCode: 451300000, name: "武宣县", level: 3 },
	{ code: 451324000, parentCode: 451300000, name: "金秀瑶族自治县", level: 3 },
	{ code: 451381000, parentCode: 451300000, name: "合山市", level: 3 },
	{ code: 451402000, parentCode: 451400000, name: "江州区", level: 3 },
	{ code: 451421000, parentCode: 451400000, name: "扶绥县", level: 3 },
	{ code: 451422000, parentCode: 451400000, name: "宁明县", level: 3 },
	{ code: 451423000, parentCode: 451400000, name: "龙州县", level: 3 },
	{ code: 451424000, parentCode: 451400000, name: "大新县", level: 3 },
	{ code: 451425000, parentCode: 451400000, name: "天等县", level: 3 },
	{ code: 451481000, parentCode: 451400000, name: "凭祥市", level: 3 },
	{ code: 450102001, parentCode: 450102000, name: "民生街道", level: 4 },
	{ code: 450102002, parentCode: 450102000, name: "朝阳街道", level: 4 },
	{ code: 450102003, parentCode: 450102000, name: "兴东街道", level: 4 },
	{ code: 450102101, parentCode: 450102000, name: "三塘镇", level: 4 },
	{ code: 450102107, parentCode: 450102000, name: "五塘镇", level: 4 },
	{ code: 450102109, parentCode: 450102000, name: "昆仑镇", level: 4 },
	{ code: 450103001, parentCode: 450103000, name: "新竹街道", level: 4 },
	{ code: 450103002, parentCode: 450103000, name: "中山街道", level: 4 },
	{ code: 450103003, parentCode: 450103000, name: "建政街道", level: 4 },
	{ code: 450103004, parentCode: 450103000, name: "南湖街道", level: 4 },
	{ code: 450103005, parentCode: 450103000, name: "津头街道", level: 4 },
	{ code: 450103100, parentCode: 450103000, name: "刘圩镇", level: 4 },
	{ code: 450103101, parentCode: 450103000, name: "南阳镇", level: 4 },
	{ code: 450103102, parentCode: 450103000, name: "伶俐镇", level: 4 },
	{ code: 450103103, parentCode: 450103000, name: "长塘镇", level: 4 },
	{ code: 450105001, parentCode: 450105000, name: "福建园街道", level: 4 },
	{ code: 450105002, parentCode: 450105000, name: "江南街道", level: 4 },
	{ code: 450105003, parentCode: 450105000, name: "沙井街道", level: 4 },
	{ code: 450105004, parentCode: 450105000, name: "那洪街道", level: 4 },
	{ code: 450105005, parentCode: 450105000, name: "金凯街道", level: 4 },
	{ code: 450105102, parentCode: 450105000, name: "吴圩镇", level: 4 },
	{ code: 450105103, parentCode: 450105000, name: "苏圩镇", level: 4 },
	{ code: 450105104, parentCode: 450105000, name: "延安镇", level: 4 },
	{ code: 450105105, parentCode: 450105000, name: "江西镇", level: 4 },
	{ code: 450107001, parentCode: 450107000, name: "衡阳街道", level: 4 },
	{ code: 450107002, parentCode: 450107000, name: "北湖街道", level: 4 },
	{ code: 450107003, parentCode: 450107000, name: "西乡塘街道", level: 4 },
	{ code: 450107004, parentCode: 450107000, name: "安吉街道", level: 4 },
	{ code: 450107005, parentCode: 450107000, name: "华强街道", level: 4 },
	{ code: 450107006, parentCode: 450107000, name: "新阳街道", level: 4 },
	{ code: 450107007, parentCode: 450107000, name: "上尧街道", level: 4 },
	{ code: 450107008, parentCode: 450107000, name: "安宁街道", level: 4 },
	{ code: 450107009, parentCode: 450107000, name: "石埠街道", level: 4 },
	{ code: 450107010, parentCode: 450107000, name: "心圩街道", level: 4 },
	{ code: 450107100, parentCode: 450107000, name: "金陵镇", level: 4 },
	{ code: 450107101, parentCode: 450107000, name: "双定镇", level: 4 },
	{ code: 450107105, parentCode: 450107000, name: "坛洛镇", level: 4 },
	{ code: 450108001, parentCode: 450108000, name: "大沙田街道", level: 4 },
	{ code: 450108002, parentCode: 450108000, name: "玉洞街道", level: 4 },
	{ code: 450108100, parentCode: 450108000, name: "良庆镇", level: 4 },
	{ code: 450108101, parentCode: 450108000, name: "那马镇", level: 4 },
	{ code: 450108102, parentCode: 450108000, name: "那陈镇", level: 4 },
	{ code: 450108103, parentCode: 450108000, name: "大塘镇", level: 4 },
	{ code: 450108104, parentCode: 450108000, name: "南晓镇", level: 4 },
	{ code: 450109100, parentCode: 450109000, name: "蒲庙镇", level: 4 },
	{ code: 450109101, parentCode: 450109000, name: "那楼镇", level: 4 },
	{ code: 450109102, parentCode: 450109000, name: "新江镇", level: 4 },
	{ code: 450109103, parentCode: 450109000, name: "百济镇", level: 4 },
	{ code: 450109104, parentCode: 450109000, name: "中和镇", level: 4 },
	{ code: 450110100, parentCode: 450110000, name: "城厢镇", level: 4 },
	{ code: 450110102, parentCode: 450110000, name: "太平镇", level: 4 },
	{ code: 450110103, parentCode: 450110000, name: "双桥镇", level: 4 },
	{ code: 450110104, parentCode: 450110000, name: "宁武镇", level: 4 },
	{ code: 450110105, parentCode: 450110000, name: "锣圩镇", level: 4 },
	{ code: 450110106, parentCode: 450110000, name: "仙湖镇", level: 4 },
	{ code: 450110107, parentCode: 450110000, name: "府城镇", level: 4 },
	{ code: 450110108, parentCode: 450110000, name: "陆斡镇", level: 4 },
	{ code: 450110109, parentCode: 450110000, name: "两江镇", level: 4 },
	{ code: 450110110, parentCode: 450110000, name: "罗波镇", level: 4 },
	{ code: 450110111, parentCode: 450110000, name: "灵马镇", level: 4 },
	{ code: 450110112, parentCode: 450110000, name: "甘圩镇", level: 4 },
	{ code: 450110113, parentCode: 450110000, name: "马头镇", level: 4 },
	{ code: 450123100, parentCode: 450123000, name: "城厢镇", level: 4 },
	{ code: 450123101, parentCode: 450123000, name: "南圩镇", level: 4 },
	{ code: 450123102, parentCode: 450123000, name: "雁江镇", level: 4 },
	{ code: 450123103, parentCode: 450123000, name: "那桐镇", level: 4 },
	{ code: 450123104, parentCode: 450123000, name: "乔建镇", level: 4 },
	{ code: 450123105, parentCode: 450123000, name: "丁当镇", level: 4 },
	{ code: 450123201, parentCode: 450123000, name: "古潭乡", level: 4 },
	{ code: 450123203, parentCode: 450123000, name: "都结乡", level: 4 },
	{ code: 450123204, parentCode: 450123000, name: "布泉乡", level: 4 },
	{ code: 450123205, parentCode: 450123000, name: "屏山乡", level: 4 },
	{ code: 450124100, parentCode: 450124000, name: "白山镇", level: 4 },
	{ code: 450124101, parentCode: 450124000, name: "百龙滩镇", level: 4 },
	{ code: 450124102, parentCode: 450124000, name: "林圩镇", level: 4 },
	{ code: 450124103, parentCode: 450124000, name: "古零镇", level: 4 },
	{ code: 450124104, parentCode: 450124000, name: "金钗镇", level: 4 },
	{ code: 450124105, parentCode: 450124000, name: "周鹿镇", level: 4 },
	{ code: 450124106, parentCode: 450124000, name: "永州镇", level: 4 },
	{ code: 450124200, parentCode: 450124000, name: "乔利乡", level: 4 },
	{ code: 450124201, parentCode: 450124000, name: "加方乡", level: 4 },
	{ code: 450124202, parentCode: 450124000, name: "古寨瑶族乡", level: 4 },
	{ code: 450124203, parentCode: 450124000, name: "里当瑶族乡", level: 4 },
	{ code: 450125100, parentCode: 450125000, name: "大丰镇", level: 4 },
	{ code: 450125101, parentCode: 450125000, name: "明亮镇", level: 4 },
	{ code: 450125102, parentCode: 450125000, name: "巷贤镇", level: 4 },
	{ code: 450125103, parentCode: 450125000, name: "白圩镇", level: 4 },
	{ code: 450125104, parentCode: 450125000, name: "三里镇", level: 4 },
	{ code: 450125105, parentCode: 450125000, name: "乔贤镇", level: 4 },
	{ code: 450125106, parentCode: 450125000, name: "西燕镇", level: 4 },
	{ code: 450125200, parentCode: 450125000, name: "澄泰乡", level: 4 },
	{ code: 450125202, parentCode: 450125000, name: "木山乡", level: 4 },
	{ code: 450125203, parentCode: 450125000, name: "塘红乡", level: 4 },
	{ code: 450125205, parentCode: 450125000, name: "镇圩瑶族乡", level: 4 },
	{ code: 450126100, parentCode: 450126000, name: "宾州镇", level: 4 },
	{ code: 450126101, parentCode: 450126000, name: "黎塘镇", level: 4 },
	{ code: 450126102, parentCode: 450126000, name: "甘棠镇", level: 4 },
	{ code: 450126103, parentCode: 450126000, name: "思陇镇", level: 4 },
	{ code: 450126104, parentCode: 450126000, name: "新桥镇", level: 4 },
	{ code: 450126105, parentCode: 450126000, name: "新圩镇", level: 4 },
	{ code: 450126106, parentCode: 450126000, name: "邹圩镇", level: 4 },
	{ code: 450126107, parentCode: 450126000, name: "大桥镇", level: 4 },
	{ code: 450126108, parentCode: 450126000, name: "武陵镇", level: 4 },
	{ code: 450126109, parentCode: 450126000, name: "中华镇", level: 4 },
	{ code: 450126110, parentCode: 450126000, name: "古辣镇", level: 4 },
	{ code: 450126111, parentCode: 450126000, name: "露圩镇", level: 4 },
	{ code: 450126112, parentCode: 450126000, name: "王灵镇", level: 4 },
	{ code: 450126113, parentCode: 450126000, name: "和吉镇", level: 4 },
	{ code: 450126114, parentCode: 450126000, name: "洋桥镇", level: 4 },
	{ code: 450126115, parentCode: 450126000, name: "陈平镇", level: 4 },
	{ code: 450181100, parentCode: 450181000, name: "横州镇", level: 4 },
	{ code: 450181101, parentCode: 450181000, name: "百合镇", level: 4 },
	{ code: 450181102, parentCode: 450181000, name: "那阳镇", level: 4 },
	{ code: 450181103, parentCode: 450181000, name: "南乡镇", level: 4 },
	{ code: 450181104, parentCode: 450181000, name: "新福镇", level: 4 },
	{ code: 450181105, parentCode: 450181000, name: "莲塘镇", level: 4 },
	{ code: 450181106, parentCode: 450181000, name: "平马镇", level: 4 },
	{ code: 450181107, parentCode: 450181000, name: "峦城镇", level: 4 },
	{ code: 450181108, parentCode: 450181000, name: "六景镇", level: 4 },
	{ code: 450181110, parentCode: 450181000, name: "石塘镇", level: 4 },
	{ code: 450181112, parentCode: 450181000, name: "陶圩镇", level: 4 },
	{ code: 450181113, parentCode: 450181000, name: "校椅镇", level: 4 },
	{ code: 450181114, parentCode: 450181000, name: "云表镇", level: 4 },
	{ code: 450181115, parentCode: 450181000, name: "马岭镇", level: 4 },
	{ code: 450181116, parentCode: 450181000, name: "马山镇", level: 4 },
	{ code: 450181117, parentCode: 450181000, name: "平朗镇", level: 4 },
	{ code: 450181204, parentCode: 450181000, name: "镇龙乡", level: 4 },
	{ code: 450202001, parentCode: 450202000, name: "城中街道", level: 4 },
	{ code: 450202002, parentCode: 450202000, name: "公园街道", level: 4 },
	{ code: 450202003, parentCode: 450202000, name: "中南街道", level: 4 },
	{ code: 450202004, parentCode: 450202000, name: "沿江街道", level: 4 },
	{ code: 450202005, parentCode: 450202000, name: "潭中街道", level: 4 },
	{ code: 450202006, parentCode: 450202000, name: "河东街道", level: 4 },
	{ code: 450202007, parentCode: 450202000, name: "静兰街道", level: 4 },
	{ code: 450203001, parentCode: 450203000, name: "天马街道", level: 4 },
	{ code: 450203002, parentCode: 450203000, name: "驾鹤街道", level: 4 },
	{ code: 450203003, parentCode: 450203000, name: "箭盘山街道", level: 4 },
	{ code: 450203004, parentCode: 450203000, name: "五里亭街道", level: 4 },
	{ code: 450203005, parentCode: 450203000, name: "荣军街道", level: 4 },
	{ code: 450203007, parentCode: 450203000, name: "白莲街道", level: 4 },
	{ code: 450203008, parentCode: 450203000, name: "麒麟街道", level: 4 },
	{ code: 450203009, parentCode: 450203000, name: "阳和街道", level: 4 },
	{ code: 450203100, parentCode: 450203000, name: "洛埠镇", level: 4 },
	{ code: 450203101, parentCode: 450203000, name: "雒容镇", level: 4 },
	{ code: 450203102, parentCode: 450203000, name: "里雍镇", level: 4 },
	{ code: 450203103, parentCode: 450203000, name: "白沙镇", level: 4 },
	{ code: 450204001, parentCode: 450204000, name: "河西街道", level: 4 },
	{ code: 450204002, parentCode: 450204000, name: "柳南街道", level: 4 },
	{ code: 450204003, parentCode: 450204000, name: "柳石街道", level: 4 },
	{ code: 450204004, parentCode: 450204000, name: "南站街道", level: 4 },
	{ code: 450204005, parentCode: 450204000, name: "鹅山街道", level: 4 },
	{ code: 450204006, parentCode: 450204000, name: "银山街道", level: 4 },
	{ code: 450204007, parentCode: 450204000, name: "潭西街道", level: 4 },
	{ code: 450204008, parentCode: 450204000, name: "南环街道", level: 4 },
	{ code: 450204100, parentCode: 450204000, name: "太阳村镇", level: 4 },
	{ code: 450204101, parentCode: 450204000, name: "洛满镇", level: 4 },
	{ code: 450204102, parentCode: 450204000, name: "流山镇", level: 4 },
	{ code: 450205001, parentCode: 450205000, name: "解放街道", level: 4 },
	{ code: 450205002, parentCode: 450205000, name: "雅儒街道", level: 4 },
	{ code: 450205003, parentCode: 450205000, name: "胜利街道", level: 4 },
	{ code: 450205004, parentCode: 450205000, name: "雀儿山街道", level: 4 },
	{ code: 450205005, parentCode: 450205000, name: "钢城街道", level: 4 },
	{ code: 450205006, parentCode: 450205000, name: "柳长街道", level: 4 },
	{ code: 450205007, parentCode: 450205000, name: "锦绣街道", level: 4 },
	{ code: 450205008, parentCode: 450205000, name: "白露街道", level: 4 },
	{ code: 450205009, parentCode: 450205000, name: "跃进街道", level: 4 },
	{ code: 450205100, parentCode: 450205000, name: "石碑坪镇", level: 4 },
	{ code: 450205101, parentCode: 450205000, name: "沙塘镇", level: 4 },
	{ code: 450205102, parentCode: 450205000, name: "长塘镇", level: 4 },
	{ code: 450206100, parentCode: 450206000, name: "拉堡镇", level: 4 },
	{ code: 450206102, parentCode: 450206000, name: "百朋镇", level: 4 },
	{ code: 450206103, parentCode: 450206000, name: "成团镇", level: 4 },
	{ code: 450206106, parentCode: 450206000, name: "三都镇", level: 4 },
	{ code: 450206107, parentCode: 450206000, name: "里高镇", level: 4 },
	{ code: 450206108, parentCode: 450206000, name: "进德镇", level: 4 },
	{ code: 450206109, parentCode: 450206000, name: "穿山镇", level: 4 },
	{ code: 450206110, parentCode: 450206000, name: "土博镇", level: 4 },
	{ code: 450222100, parentCode: 450222000, name: "大埔镇", level: 4 },
	{ code: 450222101, parentCode: 450222000, name: "龙头镇", level: 4 },
	{ code: 450222102, parentCode: 450222000, name: "太平镇", level: 4 },
	{ code: 450222103, parentCode: 450222000, name: "沙埔镇", level: 4 },
	{ code: 450222104, parentCode: 450222000, name: "东泉镇", level: 4 },
	{ code: 450222105, parentCode: 450222000, name: "凤山镇", level: 4 },
	{ code: 450222106, parentCode: 450222000, name: "六塘镇", level: 4 },
	{ code: 450222107, parentCode: 450222000, name: "冲脉镇", level: 4 },
	{ code: 450222108, parentCode: 450222000, name: "寨隆镇", level: 4 },
	{ code: 450222109, parentCode: 450222000, name: "马山镇", level: 4 },
	{ code: 450222201, parentCode: 450222000, name: "社冲乡", level: 4 },
	{ code: 450222202, parentCode: 450222000, name: "古砦仫佬族乡", level: 4 },
	{ code: 450223100, parentCode: 450223000, name: "鹿寨镇", level: 4 },
	{ code: 450223102, parentCode: 450223000, name: "中渡镇", level: 4 },
	{ code: 450223103, parentCode: 450223000, name: "寨沙镇", level: 4 },
	{ code: 450223104, parentCode: 450223000, name: "平山镇", level: 4 },
	{ code: 450223105, parentCode: 450223000, name: "黄冕镇", level: 4 },
	{ code: 450223106, parentCode: 450223000, name: "四排镇", level: 4 },
	{ code: 450223202, parentCode: 450223000, name: "江口乡", level: 4 },
	{ code: 450223203, parentCode: 450223000, name: "导江乡", level: 4 },
	{ code: 450223205, parentCode: 450223000, name: "拉沟乡", level: 4 },
	{ code: 450224100, parentCode: 450224000, name: "长安镇", level: 4 },
	{ code: 450224101, parentCode: 450224000, name: "浮石镇", level: 4 },
	{ code: 450224102, parentCode: 450224000, name: "泗顶镇", level: 4 },
	{ code: 450224103, parentCode: 450224000, name: "板榄镇", level: 4 },
	{ code: 450224104, parentCode: 450224000, name: "大将镇", level: 4 },
	{ code: 450224105, parentCode: 450224000, name: "大良镇", level: 4 },
	{ code: 450224202, parentCode: 450224000, name: "雅瑶乡", level: 4 },
	{ code: 450224203, parentCode: 450224000, name: "大坡乡", level: 4 },
	{ code: 450224204, parentCode: 450224000, name: "东起乡", level: 4 },
	{ code: 450224205, parentCode: 450224000, name: "沙子乡", level: 4 },
	{ code: 450224206, parentCode: 450224000, name: "桥板乡", level: 4 },
	{ code: 450224207, parentCode: 450224000, name: "潭头乡", level: 4 },
	{ code: 450225100, parentCode: 450225000, name: "融水镇", level: 4 },
	{ code: 450225101, parentCode: 450225000, name: "和睦镇", level: 4 },
	{ code: 450225102, parentCode: 450225000, name: "三防镇", level: 4 },
	{ code: 450225103, parentCode: 450225000, name: "怀宝镇", level: 4 },
	{ code: 450225104, parentCode: 450225000, name: "洞头镇", level: 4 },
	{ code: 450225105, parentCode: 450225000, name: "大浪镇", level: 4 },
	{ code: 450225106, parentCode: 450225000, name: "永乐镇", level: 4 },
	{ code: 450225202, parentCode: 450225000, name: "四荣乡", level: 4 },
	{ code: 450225203, parentCode: 450225000, name: "香粉乡", level: 4 },
	{ code: 450225204, parentCode: 450225000, name: "安太乡", level: 4 },
	{ code: 450225206, parentCode: 450225000, name: "汪洞乡", level: 4 },
	{ code: 450225207, parentCode: 450225000, name: "同练瑶族乡", level: 4 },
	{ code: 450225208, parentCode: 450225000, name: "滚贝侗族乡", level: 4 },
	{ code: 450225209, parentCode: 450225000, name: "杆洞乡", level: 4 },
	{ code: 450225210, parentCode: 450225000, name: "安陲乡", level: 4 },
	{ code: 450225212, parentCode: 450225000, name: "白云乡", level: 4 },
	{ code: 450225213, parentCode: 450225000, name: "红水乡", level: 4 },
	{ code: 450225214, parentCode: 450225000, name: "拱洞乡", level: 4 },
	{ code: 450225215, parentCode: 450225000, name: "良寨乡", level: 4 },
	{ code: 450225216, parentCode: 450225000, name: "大年乡", level: 4 },
	{ code: 450226100, parentCode: 450226000, name: "古宜镇", level: 4 },
	{ code: 450226101, parentCode: 450226000, name: "丹洲镇", level: 4 },
	{ code: 450226102, parentCode: 450226000, name: "斗江镇", level: 4 },
	{ code: 450226103, parentCode: 450226000, name: "林溪镇", level: 4 },
	{ code: 450226104, parentCode: 450226000, name: "八江镇", level: 4 },
	{ code: 450226105, parentCode: 450226000, name: "独峒镇", level: 4 },
	{ code: 450226201, parentCode: 450226000, name: "程村乡", level: 4 },
	{ code: 450226202, parentCode: 450226000, name: "和平乡", level: 4 },
	{ code: 450226203, parentCode: 450226000, name: "老堡乡", level: 4 },
	{ code: 450226204, parentCode: 450226000, name: "高基瑶族乡", level: 4 },
	{ code: 450226205, parentCode: 450226000, name: "良口乡", level: 4 },
	{ code: 450226206, parentCode: 450226000, name: "洋溪乡", level: 4 },
	{ code: 450226207, parentCode: 450226000, name: "富禄苗族乡", level: 4 },
	{ code: 450226208, parentCode: 450226000, name: "梅林乡", level: 4 },
	{ code: 450226212, parentCode: 450226000, name: "同乐苗族乡", level: 4 },
	{ code: 450302001, parentCode: 450302000, name: "秀峰街道", level: 4 },
	{ code: 450302002, parentCode: 450302000, name: "丽君街道", level: 4 },
	{ code: 450302003, parentCode: 450302000, name: "甲山街道", level: 4 },
	{ code: 450303001, parentCode: 450303000, name: "叠彩街道", level: 4 },
	{ code: 450303002, parentCode: 450303000, name: "北门街道", level: 4 },
	{ code: 450303200, parentCode: 450303000, name: "大河乡", level: 4 },
	{ code: 450304001, parentCode: 450304000, name: "南门街道", level: 4 },
	{ code: 450304002, parentCode: 450304000, name: "象山街道", level: 4 },
	{ code: 450304003, parentCode: 450304000, name: "平山街道", level: 4 },
	{ code: 450304200, parentCode: 450304000, name: "二塘乡", level: 4 },
	{ code: 450305001, parentCode: 450305000, name: "七星街道", level: 4 },
	{ code: 450305002, parentCode: 450305000, name: "东江街道", level: 4 },
	{ code: 450305003, parentCode: 450305000, name: "穿山街道", level: 4 },
	{ code: 450305004, parentCode: 450305000, name: "漓东街道", level: 4 },
	{ code: 450305201, parentCode: 450305000, name: "朝阳乡", level: 4 },
	{ code: 450311001, parentCode: 450311000, name: "良丰街道", level: 4 },
	{ code: 450311100, parentCode: 450311000, name: "雁山镇", level: 4 },
	{ code: 450311101, parentCode: 450311000, name: "柘木镇", level: 4 },
	{ code: 450311200, parentCode: 450311000, name: "大埠乡", level: 4 },
	{ code: 450311201, parentCode: 450311000, name: "草坪回族乡", level: 4 },
	{ code: 450312100, parentCode: 450312000, name: "临桂镇", level: 4 },
	{ code: 450312101, parentCode: 450312000, name: "六塘镇", level: 4 },
	{ code: 450312102, parentCode: 450312000, name: "会仙镇", level: 4 },
	{ code: 450312103, parentCode: 450312000, name: "两江镇", level: 4 },
	{ code: 450312104, parentCode: 450312000, name: "五通镇", level: 4 },
	{ code: 450312105, parentCode: 450312000, name: "四塘镇", level: 4 },
	{ code: 450312106, parentCode: 450312000, name: "南边山镇", level: 4 },
	{ code: 450312107, parentCode: 450312000, name: "中庸镇", level: 4 },
	{ code: 450312108, parentCode: 450312000, name: "茶洞镇", level: 4 },
	{ code: 450312203, parentCode: 450312000, name: "宛田瑶族乡", level: 4 },
	{ code: 450312204, parentCode: 450312000, name: "黄沙瑶族乡", level: 4 },
	{ code: 450321100, parentCode: 450321000, name: "阳朔镇", level: 4 },
	{ code: 450321101, parentCode: 450321000, name: "白沙镇", level: 4 },
	{ code: 450321102, parentCode: 450321000, name: "福利镇", level: 4 },
	{ code: 450321103, parentCode: 450321000, name: "兴坪镇", level: 4 },
	{ code: 450321104, parentCode: 450321000, name: "葡萄镇", level: 4 },
	{ code: 450321105, parentCode: 450321000, name: "高田镇", level: 4 },
	{ code: 450321200, parentCode: 450321000, name: "金宝乡", level: 4 },
	{ code: 450321201, parentCode: 450321000, name: "普益乡", level: 4 },
	{ code: 450321202, parentCode: 450321000, name: "杨堤乡", level: 4 },
	{ code: 450323100, parentCode: 450323000, name: "灵川镇", level: 4 },
	{ code: 450323101, parentCode: 450323000, name: "大圩镇", level: 4 },
	{ code: 450323102, parentCode: 450323000, name: "定江镇", level: 4 },
	{ code: 450323103, parentCode: 450323000, name: "三街镇", level: 4 },
	{ code: 450323104, parentCode: 450323000, name: "潭下镇", level: 4 },
	{ code: 450323106, parentCode: 450323000, name: "九屋镇", level: 4 },
	{ code: 450323107, parentCode: 450323000, name: "灵田镇", level: 4 },
	{ code: 450323200, parentCode: 450323000, name: "潮田乡", level: 4 },
	{ code: 450323201, parentCode: 450323000, name: "大境瑶族乡", level: 4 },
	{ code: 450323202, parentCode: 450323000, name: "海洋乡", level: 4 },
	{ code: 450323206, parentCode: 450323000, name: "兰田瑶族乡", level: 4 },
	{ code: 450323207, parentCode: 450323000, name: "公平乡", level: 4 },
	{ code: 450324100, parentCode: 450324000, name: "全州镇", level: 4 },
	{ code: 450324101, parentCode: 450324000, name: "黄沙河镇", level: 4 },
	{ code: 450324102, parentCode: 450324000, name: "庙头镇", level: 4 },
	{ code: 450324103, parentCode: 450324000, name: "文桥镇", level: 4 },
	{ code: 450324104, parentCode: 450324000, name: "大西江镇", level: 4 },
	{ code: 450324105, parentCode: 450324000, name: "龙水镇", level: 4 },
	{ code: 450324106, parentCode: 450324000, name: "才湾镇", level: 4 },
	{ code: 450324107, parentCode: 450324000, name: "绍水镇", level: 4 },
	{ code: 450324108, parentCode: 450324000, name: "石塘镇", level: 4 },
	{ code: 450324109, parentCode: 450324000, name: "安和镇", level: 4 },
	{ code: 450324110, parentCode: 450324000, name: "两河镇", level: 4 },
	{ code: 450324111, parentCode: 450324000, name: "凤凰镇", level: 4 },
	{ code: 450324112, parentCode: 450324000, name: "咸水镇", level: 4 },
	{ code: 450324113, parentCode: 450324000, name: "枧塘镇", level: 4 },
	{ code: 450324114, parentCode: 450324000, name: "永岁镇", level: 4 },
	{ code: 450324204, parentCode: 450324000, name: "蕉江瑶族乡", level: 4 },
	{ code: 450324208, parentCode: 450324000, name: "白宝乡", level: 4 },
	{ code: 450324209, parentCode: 450324000, name: "东山瑶族乡", level: 4 },
	{ code: 450325100, parentCode: 450325000, name: "兴安镇", level: 4 },
	{ code: 450325101, parentCode: 450325000, name: "湘漓镇", level: 4 },
	{ code: 450325102, parentCode: 450325000, name: "界首镇", level: 4 },
	{ code: 450325103, parentCode: 450325000, name: "高尚镇", level: 4 },
	{ code: 450325104, parentCode: 450325000, name: "严关镇", level: 4 },
	{ code: 450325105, parentCode: 450325000, name: "溶江镇", level: 4 },
	{ code: 450325200, parentCode: 450325000, name: "漠川乡", level: 4 },
	{ code: 450325201, parentCode: 450325000, name: "白石乡", level: 4 },
	{ code: 450325202, parentCode: 450325000, name: "崔家乡", level: 4 },
	{ code: 450325203, parentCode: 450325000, name: "华江瑶族乡", level: 4 },
	{ code: 450326100, parentCode: 450326000, name: "永福镇", level: 4 },
	{ code: 450326101, parentCode: 450326000, name: "罗锦镇", level: 4 },
	{ code: 450326102, parentCode: 450326000, name: "百寿镇", level: 4 },
	{ code: 450326103, parentCode: 450326000, name: "苏桥镇", level: 4 },
	{ code: 450326104, parentCode: 450326000, name: "三皇镇", level: 4 },
	{ code: 450326105, parentCode: 450326000, name: "堡里镇", level: 4 },
	{ code: 450326202, parentCode: 450326000, name: "广福乡", level: 4 },
	{ code: 450326204, parentCode: 450326000, name: "永安乡", level: 4 },
	{ code: 450326205, parentCode: 450326000, name: "龙江乡", level: 4 },
	{ code: 450327100, parentCode: 450327000, name: "灌阳镇", level: 4 },
	{ code: 450327101, parentCode: 450327000, name: "黄关镇", level: 4 },
	{ code: 450327102, parentCode: 450327000, name: "文市镇", level: 4 },
	{ code: 450327103, parentCode: 450327000, name: "新街镇", level: 4 },
	{ code: 450327104, parentCode: 450327000, name: "新圩镇", level: 4 },
	{ code: 450327105, parentCode: 450327000, name: "水车镇", level: 4 },
	{ code: 450327200, parentCode: 450327000, name: "洞井瑶族乡", level: 4 },
	{ code: 450327201, parentCode: 450327000, name: "观音阁乡", level: 4 },
	{ code: 450327202, parentCode: 450327000, name: "西山瑶族乡", level: 4 },
	{ code: 450328100, parentCode: 450328000, name: "龙胜镇", level: 4 },
	{ code: 450328101, parentCode: 450328000, name: "瓢里镇", level: 4 },
	{ code: 450328102, parentCode: 450328000, name: "三门镇", level: 4 },
	{ code: 450328103, parentCode: 450328000, name: "平等镇", level: 4 },
	{ code: 450328104, parentCode: 450328000, name: "龙脊镇", level: 4 },
	{ code: 450328105, parentCode: 450328000, name: "乐江镇", level: 4 },
	{ code: 450328201, parentCode: 450328000, name: "泗水乡", level: 4 },
	{ code: 450328202, parentCode: 450328000, name: "江底乡", level: 4 },
	{ code: 450328203, parentCode: 450328000, name: "马堤乡", level: 4 },
	{ code: 450328204, parentCode: 450328000, name: "伟江乡", level: 4 },
	{ code: 450329101, parentCode: 450329000, name: "资源镇", level: 4 },
	{ code: 450329102, parentCode: 450329000, name: "梅溪镇", level: 4 },
	{ code: 450329103, parentCode: 450329000, name: "中峰镇", level: 4 },
	{ code: 450329203, parentCode: 450329000, name: "瓜里乡", level: 4 },
	{ code: 450329204, parentCode: 450329000, name: "车田苗族乡", level: 4 },
	{ code: 450329205, parentCode: 450329000, name: "两水苗族乡", level: 4 },
	{ code: 450329206, parentCode: 450329000, name: "河口瑶族乡", level: 4 },
	{ code: 450330100, parentCode: 450330000, name: "平乐镇", level: 4 },
	{ code: 450330101, parentCode: 450330000, name: "二塘镇", level: 4 },
	{ code: 450330102, parentCode: 450330000, name: "沙子镇", level: 4 },
	{ code: 450330103, parentCode: 450330000, name: "同安镇", level: 4 },
	{ code: 450330104, parentCode: 450330000, name: "张家镇", level: 4 },
	{ code: 450330105, parentCode: 450330000, name: "源头镇", level: 4 },
	{ code: 450330201, parentCode: 450330000, name: "阳安乡", level: 4 },
	{ code: 450330202, parentCode: 450330000, name: "青龙乡", level: 4 },
	{ code: 450330203, parentCode: 450330000, name: "桥亭乡", level: 4 },
	{ code: 450330205, parentCode: 450330000, name: "大发瑶族乡", level: 4 },
	{ code: 450332100, parentCode: 450332000, name: "恭城镇", level: 4 },
	{ code: 450332101, parentCode: 450332000, name: "栗木镇", level: 4 },
	{ code: 450332102, parentCode: 450332000, name: "莲花镇", level: 4 },
	{ code: 450332103, parentCode: 450332000, name: "嘉会镇", level: 4 },
	{ code: 450332104, parentCode: 450332000, name: "西岭镇", level: 4 },
	{ code: 450332105, parentCode: 450332000, name: "平安镇", level: 4 },
	{ code: 450332201, parentCode: 450332000, name: "三江乡", level: 4 },
	{ code: 450332204, parentCode: 450332000, name: "观音乡", level: 4 },
	{ code: 450332205, parentCode: 450332000, name: "龙虎乡", level: 4 },
	{ code: 450381100, parentCode: 450381000, name: "荔城镇", level: 4 },
	{ code: 450381101, parentCode: 450381000, name: "东昌镇", level: 4 },
	{ code: 450381102, parentCode: 450381000, name: "新坪镇", level: 4 },
	{ code: 450381103, parentCode: 450381000, name: "杜莫镇", level: 4 },
	{ code: 450381104, parentCode: 450381000, name: "青山镇", level: 4 },
	{ code: 450381105, parentCode: 450381000, name: "修仁镇", level: 4 },
	{ code: 450381106, parentCode: 450381000, name: "大塘镇", level: 4 },
	{ code: 450381107, parentCode: 450381000, name: "花篢镇", level: 4 },
	{ code: 450381108, parentCode: 450381000, name: "双江镇", level: 4 },
	{ code: 450381109, parentCode: 450381000, name: "马岭镇", level: 4 },
	{ code: 450381200, parentCode: 450381000, name: "龙怀乡", level: 4 },
	{ code: 450381201, parentCode: 450381000, name: "茶城乡", level: 4 },
	{ code: 450381202, parentCode: 450381000, name: "蒲芦瑶族乡", level: 4 },
	{ code: 450403002, parentCode: 450403000, name: "城南街道", level: 4 },
	{ code: 450403004, parentCode: 450403000, name: "城北街道", level: 4 },
	{ code: 450403005, parentCode: 450403000, name: "角嘴街道", level: 4 },
	{ code: 450403006, parentCode: 450403000, name: "东兴街道", level: 4 },
	{ code: 450403007, parentCode: 450403000, name: "富民街道", level: 4 },
	{ code: 450403105, parentCode: 450403000, name: "城东镇", level: 4 },
	{ code: 450403107, parentCode: 450403000, name: "龙湖镇", level: 4 },
	{ code: 450403108, parentCode: 450403000, name: "夏郢镇", level: 4 },
	{ code: 450405001, parentCode: 450405000, name: "大塘街道", level: 4 },
	{ code: 450405002, parentCode: 450405000, name: "兴龙街道", level: 4 },
	{ code: 450405003, parentCode: 450405000, name: "红岭街道", level: 4 },
	{ code: 450405101, parentCode: 450405000, name: "长洲镇", level: 4 },
	{ code: 450405102, parentCode: 450405000, name: "倒水镇", level: 4 },
	{ code: 450406100, parentCode: 450406000, name: "龙圩镇", level: 4 },
	{ code: 450406101, parentCode: 450406000, name: "新地镇", level: 4 },
	{ code: 450406102, parentCode: 450406000, name: "广平镇", level: 4 },
	{ code: 450406103, parentCode: 450406000, name: "大坡镇", level: 4 },
	{ code: 450421105, parentCode: 450421000, name: "岭脚镇", level: 4 },
	{ code: 450421108, parentCode: 450421000, name: "京南镇", level: 4 },
	{ code: 450421109, parentCode: 450421000, name: "狮寨镇", level: 4 },
	{ code: 450421112, parentCode: 450421000, name: "六堡镇", level: 4 },
	{ code: 450421113, parentCode: 450421000, name: "梨埠镇", level: 4 },
	{ code: 450421114, parentCode: 450421000, name: "木双镇", level: 4 },
	{ code: 450421115, parentCode: 450421000, name: "石桥镇", level: 4 },
	{ code: 450421116, parentCode: 450421000, name: "沙头镇", level: 4 },
	{ code: 450421117, parentCode: 450421000, name: "旺甫镇", level: 4 },
	{ code: 450422100, parentCode: 450422000, name: "藤州镇", level: 4 },
	{ code: 450422103, parentCode: 450422000, name: "塘步镇", level: 4 },
	{ code: 450422104, parentCode: 450422000, name: "埌南镇", level: 4 },
	{ code: 450422105, parentCode: 450422000, name: "同心镇", level: 4 },
	{ code: 450422106, parentCode: 450422000, name: "金鸡镇", level: 4 },
	{ code: 450422107, parentCode: 450422000, name: "新庆镇", level: 4 },
	{ code: 450422108, parentCode: 450422000, name: "象棋镇", level: 4 },
	{ code: 450422109, parentCode: 450422000, name: "岭景镇", level: 4 },
	{ code: 450422110, parentCode: 450422000, name: "天平镇", level: 4 },
	{ code: 450422111, parentCode: 450422000, name: "濛江镇", level: 4 },
	{ code: 450422112, parentCode: 450422000, name: "和平镇", level: 4 },
	{ code: 450422113, parentCode: 450422000, name: "太平镇", level: 4 },
	{ code: 450422114, parentCode: 450422000, name: "古龙镇", level: 4 },
	{ code: 450422115, parentCode: 450422000, name: "东荣镇", level: 4 },
	{ code: 450422116, parentCode: 450422000, name: "大黎镇", level: 4 },
	{ code: 450422200, parentCode: 450422000, name: "平福乡", level: 4 },
	{ code: 450422201, parentCode: 450422000, name: "宁康乡", level: 4 },
	{ code: 450423100, parentCode: 450423000, name: "蒙山镇", level: 4 },
	{ code: 450423101, parentCode: 450423000, name: "西河镇", level: 4 },
	{ code: 450423102, parentCode: 450423000, name: "新圩镇", level: 4 },
	{ code: 450423103, parentCode: 450423000, name: "文圩镇", level: 4 },
	{ code: 450423104, parentCode: 450423000, name: "黄村镇", level: 4 },
	{ code: 450423105, parentCode: 450423000, name: "陈塘镇", level: 4 },
	{ code: 450423200, parentCode: 450423000, name: "汉豪乡", level: 4 },
	{ code: 450423201, parentCode: 450423000, name: "长坪瑶族乡", level: 4 },
	{ code: 450423202, parentCode: 450423000, name: "夏宜瑶族乡", level: 4 },
	{ code: 450481100, parentCode: 450481000, name: "岑城镇", level: 4 },
	{ code: 450481102, parentCode: 450481000, name: "马路镇", level: 4 },
	{ code: 450481103, parentCode: 450481000, name: "南渡镇", level: 4 },
	{ code: 450481105, parentCode: 450481000, name: "水汶镇", level: 4 },
	{ code: 450481106, parentCode: 450481000, name: "大隆镇", level: 4 },
	{ code: 450481107, parentCode: 450481000, name: "梨木镇", level: 4 },
	{ code: 450481108, parentCode: 450481000, name: "大业镇", level: 4 },
	{ code: 450481109, parentCode: 450481000, name: "筋竹镇", level: 4 },
	{ code: 450481110, parentCode: 450481000, name: "诚谏镇", level: 4 },
	{ code: 450481111, parentCode: 450481000, name: "归义镇", level: 4 },
	{ code: 450481112, parentCode: 450481000, name: "糯垌镇", level: 4 },
	{ code: 450481113, parentCode: 450481000, name: "安平镇", level: 4 },
	{ code: 450481114, parentCode: 450481000, name: "三堡镇", level: 4 },
	{ code: 450481115, parentCode: 450481000, name: "波塘镇", level: 4 },
	{ code: 450502001, parentCode: 450502000, name: "中街街道", level: 4 },
	{ code: 450502002, parentCode: 450502000, name: "东街街道", level: 4 },
	{ code: 450502003, parentCode: 450502000, name: "西街街道", level: 4 },
	{ code: 450502004, parentCode: 450502000, name: "海角街道", level: 4 },
	{ code: 450502005, parentCode: 450502000, name: "地角街道", level: 4 },
	{ code: 450502006, parentCode: 450502000, name: "高德街道", level: 4 },
	{ code: 450502007, parentCode: 450502000, name: "驿马街道", level: 4 },
	{ code: 450502100, parentCode: 450502000, name: "涠洲镇", level: 4 },
	{ code: 450503100, parentCode: 450503000, name: "福成镇", level: 4 },
	{ code: 450503101, parentCode: 450503000, name: "银滩镇", level: 4 },
	{ code: 450503102, parentCode: 450503000, name: "平阳镇", level: 4 },
	{ code: 450503103, parentCode: 450503000, name: "侨港镇", level: 4 },
	{ code: 450512100, parentCode: 450512000, name: "南康镇", level: 4 },
	{ code: 450512101, parentCode: 450512000, name: "营盘镇", level: 4 },
	{ code: 450512102, parentCode: 450512000, name: "兴港镇", level: 4 },
	{ code: 450521100, parentCode: 450521000, name: "廉州镇", level: 4 },
	{ code: 450521101, parentCode: 450521000, name: "党江镇", level: 4 },
	{ code: 450521102, parentCode: 450521000, name: "西场镇", level: 4 },
	{ code: 450521103, parentCode: 450521000, name: "沙岗镇", level: 4 },
	{ code: 450521104, parentCode: 450521000, name: "乌家镇", level: 4 },
	{ code: 450521105, parentCode: 450521000, name: "闸口镇", level: 4 },
	{ code: 450521106, parentCode: 450521000, name: "公馆镇", level: 4 },
	{ code: 450521107, parentCode: 450521000, name: "白沙镇", level: 4 },
	{ code: 450521108, parentCode: 450521000, name: "山口镇", level: 4 },
	{ code: 450521109, parentCode: 450521000, name: "沙田镇", level: 4 },
	{ code: 450521110, parentCode: 450521000, name: "石湾镇", level: 4 },
	{ code: 450521111, parentCode: 450521000, name: "石康镇", level: 4 },
	{ code: 450521112, parentCode: 450521000, name: "常乐镇", level: 4 },
	{ code: 450521113, parentCode: 450521000, name: "星岛湖镇", level: 4 },
	{ code: 450521200, parentCode: 450521000, name: "曲樟乡", level: 4 },
	{ code: 450602001, parentCode: 450602000, name: "渔洲坪街道", level: 4 },
	{ code: 450602002, parentCode: 450602000, name: "白沙𬇕街道", level: 4 },
	{ code: 450602003, parentCode: 450602000, name: "沙潭江街道", level: 4 },
	{ code: 450602004, parentCode: 450602000, name: "王府街道", level: 4 },
	{ code: 450602100, parentCode: 450602000, name: "企沙镇", level: 4 },
	{ code: 450602101, parentCode: 450602000, name: "光坡镇", level: 4 },
	{ code: 450603001, parentCode: 450603000, name: "水营街道", level: 4 },
	{ code: 450603002, parentCode: 450603000, name: "珠河街道", level: 4 },
	{ code: 450603003, parentCode: 450603000, name: "文昌街道", level: 4 },
	{ code: 450603101, parentCode: 450603000, name: "大菉镇", level: 4 },
	{ code: 450603102, parentCode: 450603000, name: "华石镇", level: 4 },
	{ code: 450603103, parentCode: 450603000, name: "那梭镇", level: 4 },
	{ code: 450603104, parentCode: 450603000, name: "那良镇", level: 4 },
	{ code: 450603105, parentCode: 450603000, name: "峒中镇", level: 4 },
	{ code: 450603106, parentCode: 450603000, name: "茅岭镇", level: 4 },
	{ code: 450603107, parentCode: 450603000, name: "江山镇", level: 4 },
	{ code: 450603108, parentCode: 450603000, name: "扶隆镇", level: 4 },
	{ code: 450603204, parentCode: 450603000, name: "滩营乡", level: 4 },
	{ code: 450603209, parentCode: 450603000, name: "十万山瑶族乡", level: 4 },
	{ code: 450621100, parentCode: 450621000, name: "思阳镇", level: 4 },
	{ code: 450621101, parentCode: 450621000, name: "在妙镇", level: 4 },
	{ code: 450621102, parentCode: 450621000, name: "华兰镇", level: 4 },
	{ code: 450621103, parentCode: 450621000, name: "叫安镇", level: 4 },
	{ code: 450621203, parentCode: 450621000, name: "南屏瑶族乡", level: 4 },
	{ code: 450621204, parentCode: 450621000, name: "平福乡", level: 4 },
	{ code: 450621206, parentCode: 450621000, name: "那琴乡", level: 4 },
	{ code: 450621208, parentCode: 450621000, name: "公正乡", level: 4 },
	{ code: 450681100, parentCode: 450681000, name: "东兴镇", level: 4 },
	{ code: 450681101, parentCode: 450681000, name: "江平镇", level: 4 },
	{ code: 450681102, parentCode: 450681000, name: "马路镇", level: 4 },
	{ code: 450702001, parentCode: 450702000, name: "向阳街道", level: 4 },
	{ code: 450702002, parentCode: 450702000, name: "水东街道", level: 4 },
	{ code: 450702003, parentCode: 450702000, name: "文峰街道", level: 4 },
	{ code: 450702004, parentCode: 450702000, name: "南珠街道", level: 4 },
	{ code: 450702005, parentCode: 450702000, name: "尖山街道", level: 4 },
	{ code: 450702100, parentCode: 450702000, name: "沙埠镇", level: 4 },
	{ code: 450702101, parentCode: 450702000, name: "康熙岭镇", level: 4 },
	{ code: 450702102, parentCode: 450702000, name: "黄屋屯镇", level: 4 },
	{ code: 450702104, parentCode: 450702000, name: "大番坡镇", level: 4 },
	{ code: 450702105, parentCode: 450702000, name: "龙门港镇", level: 4 },
	{ code: 450702106, parentCode: 450702000, name: "犀牛脚镇", level: 4 },
	{ code: 450702107, parentCode: 450702000, name: "久隆镇", level: 4 },
	{ code: 450702108, parentCode: 450702000, name: "东场镇", level: 4 },
	{ code: 450702109, parentCode: 450702000, name: "那丽镇", level: 4 },
	{ code: 450702110, parentCode: 450702000, name: "那彭镇", level: 4 },
	{ code: 450702111, parentCode: 450702000, name: "那思镇", level: 4 },
	{ code: 450703001, parentCode: 450703000, name: "长田街道", level: 4 },
	{ code: 450703002, parentCode: 450703000, name: "鸿亭街道", level: 4 },
	{ code: 450703003, parentCode: 450703000, name: "子材街道", level: 4 },
	{ code: 450703100, parentCode: 450703000, name: "大垌镇", level: 4 },
	{ code: 450703101, parentCode: 450703000, name: "平吉镇", level: 4 },
	{ code: 450703102, parentCode: 450703000, name: "青塘镇", level: 4 },
	{ code: 450703103, parentCode: 450703000, name: "小董镇", level: 4 },
	{ code: 450703104, parentCode: 450703000, name: "板城镇", level: 4 },
	{ code: 450703106, parentCode: 450703000, name: "那蒙镇", level: 4 },
	{ code: 450703107, parentCode: 450703000, name: "长滩镇", level: 4 },
	{ code: 450703108, parentCode: 450703000, name: "新棠镇", level: 4 },
	{ code: 450703109, parentCode: 450703000, name: "大直镇", level: 4 },
	{ code: 450703110, parentCode: 450703000, name: "大寺镇", level: 4 },
	{ code: 450703111, parentCode: 450703000, name: "贵台镇", level: 4 },
	{ code: 450721001, parentCode: 450721000, name: "三海街道", level: 4 },
	{ code: 450721002, parentCode: 450721000, name: "灵城街道", level: 4 },
	{ code: 450721102, parentCode: 450721000, name: "新圩镇", level: 4 },
	{ code: 450721103, parentCode: 450721000, name: "丰塘镇", level: 4 },
	{ code: 450721104, parentCode: 450721000, name: "平山镇", level: 4 },
	{ code: 450721105, parentCode: 450721000, name: "石塘镇", level: 4 },
	{ code: 450721106, parentCode: 450721000, name: "佛子镇", level: 4 },
	{ code: 450721107, parentCode: 450721000, name: "平南镇", level: 4 },
	{ code: 450721108, parentCode: 450721000, name: "烟墩镇", level: 4 },
	{ code: 450721109, parentCode: 450721000, name: "檀圩镇", level: 4 },
	{ code: 450721110, parentCode: 450721000, name: "那隆镇", level: 4 },
	{ code: 450721111, parentCode: 450721000, name: "三隆镇", level: 4 },
	{ code: 450721112, parentCode: 450721000, name: "陆屋镇", level: 4 },
	{ code: 450721113, parentCode: 450721000, name: "旧州镇", level: 4 },
	{ code: 450721114, parentCode: 450721000, name: "太平镇", level: 4 },
	{ code: 450721115, parentCode: 450721000, name: "沙坪镇", level: 4 },
	{ code: 450721116, parentCode: 450721000, name: "武利镇", level: 4 },
	{ code: 450721117, parentCode: 450721000, name: "文利镇", level: 4 },
	{ code: 450721118, parentCode: 450721000, name: "伯劳镇", level: 4 },
	{ code: 450722001, parentCode: 450722000, name: "小江街道", level: 4 },
	{ code: 450722002, parentCode: 450722000, name: "江城街道", level: 4 },
	{ code: 450722101, parentCode: 450722000, name: "泉水镇", level: 4 },
	{ code: 450722102, parentCode: 450722000, name: "石埇镇", level: 4 },
	{ code: 450722103, parentCode: 450722000, name: "安石镇", level: 4 },
	{ code: 450722104, parentCode: 450722000, name: "张黄镇", level: 4 },
	{ code: 450722105, parentCode: 450722000, name: "大成镇", level: 4 },
	{ code: 450722106, parentCode: 450722000, name: "白石水镇", level: 4 },
	{ code: 450722107, parentCode: 450722000, name: "北通镇", level: 4 },
	{ code: 450722108, parentCode: 450722000, name: "三合镇", level: 4 },
	{ code: 450722109, parentCode: 450722000, name: "龙门镇", level: 4 },
	{ code: 450722111, parentCode: 450722000, name: "福旺镇", level: 4 },
	{ code: 450722112, parentCode: 450722000, name: "寨圩镇", level: 4 },
	{ code: 450722113, parentCode: 450722000, name: "乐民镇", level: 4 },
	{ code: 450722114, parentCode: 450722000, name: "六硍镇", level: 4 },
	{ code: 450722115, parentCode: 450722000, name: "平睦镇", level: 4 },
	{ code: 450722116, parentCode: 450722000, name: "官垌镇", level: 4 },
	{ code: 450802001, parentCode: 450802000, name: "贵城街道", level: 4 },
	{ code: 450802002, parentCode: 450802000, name: "港城街道", level: 4 },
	{ code: 450802003, parentCode: 450802000, name: "荷城街道", level: 4 },
	{ code: 450802004, parentCode: 450802000, name: "布山街道", level: 4 },
	{ code: 450802005, parentCode: 450802000, name: "西江街道", level: 4 },
	{ code: 450802101, parentCode: 450802000, name: "大圩镇", level: 4 },
	{ code: 450802102, parentCode: 450802000, name: "庆丰镇", level: 4 },
	{ code: 450802103, parentCode: 450802000, name: "根竹镇", level: 4 },
	{ code: 450802104, parentCode: 450802000, name: "武乐镇", level: 4 },
	{ code: 450802200, parentCode: 450802000, name: "奇石乡", level: 4 },
	{ code: 450802201, parentCode: 450802000, name: "中里乡", level: 4 },
	{ code: 450803001, parentCode: 450803000, name: "江南街道", level: 4 },
	{ code: 450803002, parentCode: 450803000, name: "八塘街道", level: 4 },
	{ code: 450803100, parentCode: 450803000, name: "桥圩镇", level: 4 },
	{ code: 450803101, parentCode: 450803000, name: "木格镇", level: 4 },
	{ code: 450803102, parentCode: 450803000, name: "木梓镇", level: 4 },
	{ code: 450803103, parentCode: 450803000, name: "湛江镇", level: 4 },
	{ code: 450803104, parentCode: 450803000, name: "东津镇", level: 4 },
	{ code: 450803106, parentCode: 450803000, name: "新塘镇", level: 4 },
	{ code: 450803107, parentCode: 450803000, name: "瓦塘镇", level: 4 },
	{ code: 450804001, parentCode: 450804000, name: "覃塘街道", level: 4 },
	{ code: 450804101, parentCode: 450804000, name: "东龙镇", level: 4 },
	{ code: 450804102, parentCode: 450804000, name: "三里镇", level: 4 },
	{ code: 450804103, parentCode: 450804000, name: "黄练镇", level: 4 },
	{ code: 450804104, parentCode: 450804000, name: "石卡镇", level: 4 },
	{ code: 450804105, parentCode: 450804000, name: "五里镇", level: 4 },
	{ code: 450804106, parentCode: 450804000, name: "樟木镇", level: 4 },
	{ code: 450804107, parentCode: 450804000, name: "蒙公镇", level: 4 },
	{ code: 450804200, parentCode: 450804000, name: "山北乡", level: 4 },
	{ code: 450804203, parentCode: 450804000, name: "大岭乡", level: 4 },
	{ code: 450821001, parentCode: 450821000, name: "平南街道", level: 4 },
	{ code: 450821002, parentCode: 450821000, name: "上渡街道", level: 4 },
	{ code: 450821101, parentCode: 450821000, name: "平山镇", level: 4 },
	{ code: 450821102, parentCode: 450821000, name: "寺面镇", level: 4 },
	{ code: 450821103, parentCode: 450821000, name: "六陈镇", level: 4 },
	{ code: 450821104, parentCode: 450821000, name: "大新镇", level: 4 },
	{ code: 450821105, parentCode: 450821000, name: "大安镇", level: 4 },
	{ code: 450821106, parentCode: 450821000, name: "武林镇", level: 4 },
	{ code: 450821107, parentCode: 450821000, name: "大坡镇", level: 4 },
	{ code: 450821108, parentCode: 450821000, name: "大洲镇", level: 4 },
	{ code: 450821109, parentCode: 450821000, name: "镇隆镇", level: 4 },
	{ code: 450821112, parentCode: 450821000, name: "安怀镇", level: 4 },
	{ code: 450821113, parentCode: 450821000, name: "丹竹镇", level: 4 },
	{ code: 450821114, parentCode: 450821000, name: "官成镇", level: 4 },
	{ code: 450821115, parentCode: 450821000, name: "思旺镇", level: 4 },
	{ code: 450821116, parentCode: 450821000, name: "大鹏镇", level: 4 },
	{ code: 450821117, parentCode: 450821000, name: "同和镇", level: 4 },
	{ code: 450821118, parentCode: 450821000, name: "东华镇", level: 4 },
	{ code: 450821202, parentCode: 450821000, name: "思界乡", level: 4 },
	{ code: 450821203, parentCode: 450821000, name: "国安瑶族乡", level: 4 },
	{ code: 450821204, parentCode: 450821000, name: "马练瑶族乡", level: 4 },
	{ code: 450881100, parentCode: 450881000, name: "西山镇", level: 4 },
	{ code: 450881101, parentCode: 450881000, name: "木乐镇", level: 4 },
	{ code: 450881102, parentCode: 450881000, name: "木圭镇", level: 4 },
	{ code: 450881103, parentCode: 450881000, name: "石咀镇", level: 4 },
	{ code: 450881104, parentCode: 450881000, name: "油麻镇", level: 4 },
	{ code: 450881105, parentCode: 450881000, name: "社坡镇", level: 4 },
	{ code: 450881106, parentCode: 450881000, name: "罗秀镇", level: 4 },
	{ code: 450881107, parentCode: 450881000, name: "麻垌镇", level: 4 },
	{ code: 450881108, parentCode: 450881000, name: "社步镇", level: 4 },
	{ code: 450881109, parentCode: 450881000, name: "下湾镇", level: 4 },
	{ code: 450881110, parentCode: 450881000, name: "木根镇", level: 4 },
	{ code: 450881111, parentCode: 450881000, name: "中沙镇", level: 4 },
	{ code: 450881113, parentCode: 450881000, name: "大洋镇", level: 4 },
	{ code: 450881114, parentCode: 450881000, name: "大湾镇", level: 4 },
	{ code: 450881115, parentCode: 450881000, name: "白沙镇", level: 4 },
	{ code: 450881116, parentCode: 450881000, name: "石龙镇", level: 4 },
	{ code: 450881117, parentCode: 450881000, name: "蒙圩镇", level: 4 },
	{ code: 450881118, parentCode: 450881000, name: "紫荆镇", level: 4 },
	{ code: 450881119, parentCode: 450881000, name: "南木镇", level: 4 },
	{ code: 450881120, parentCode: 450881000, name: "江口镇", level: 4 },
	{ code: 450881121, parentCode: 450881000, name: "金田镇", level: 4 },
	{ code: 450881200, parentCode: 450881000, name: "马皮乡", level: 4 },
	{ code: 450881201, parentCode: 450881000, name: "垌心乡", level: 4 },
	{ code: 450881202, parentCode: 450881000, name: "寻旺乡", level: 4 },
	{ code: 450881203, parentCode: 450881000, name: "罗播乡", level: 4 },
	{ code: 450881204, parentCode: 450881000, name: "厚禄乡", level: 4 },
	{ code: 450902001, parentCode: 450902000, name: "玉城街道", level: 4 },
	{ code: 450902002, parentCode: 450902000, name: "南江街道", level: 4 },
	{ code: 450902003, parentCode: 450902000, name: "城西街道", level: 4 },
	{ code: 450902004, parentCode: 450902000, name: "城北街道", level: 4 },
	{ code: 450902005, parentCode: 450902000, name: "名山街道", level: 4 },
	{ code: 450902101, parentCode: 450902000, name: "茂林镇", level: 4 },
	{ code: 450902102, parentCode: 450902000, name: "仁东镇", level: 4 },
	{ code: 450902103, parentCode: 450902000, name: "仁厚镇", level: 4 },
	{ code: 450902104, parentCode: 450902000, name: "大塘镇", level: 4 },
	{ code: 450903100, parentCode: 450903000, name: "福绵镇", level: 4 },
	{ code: 450903101, parentCode: 450903000, name: "成均镇", level: 4 },
	{ code: 450903102, parentCode: 450903000, name: "樟木镇", level: 4 },
	{ code: 450903103, parentCode: 450903000, name: "新桥镇", level: 4 },
	{ code: 450903104, parentCode: 450903000, name: "沙田镇", level: 4 },
	{ code: 450903105, parentCode: 450903000, name: "石和镇", level: 4 },
	{ code: 450921100, parentCode: 450921000, name: "容州镇", level: 4 },
	{ code: 450921102, parentCode: 450921000, name: "杨梅镇", level: 4 },
	{ code: 450921103, parentCode: 450921000, name: "灵山镇", level: 4 },
	{ code: 450921104, parentCode: 450921000, name: "六王镇", level: 4 },
	{ code: 450921105, parentCode: 450921000, name: "黎村镇", level: 4 },
	{ code: 450921106, parentCode: 450921000, name: "杨村镇", level: 4 },
	{ code: 450921107, parentCode: 450921000, name: "县底镇", level: 4 },
	{ code: 450921108, parentCode: 450921000, name: "自良镇", level: 4 },
	{ code: 450921109, parentCode: 450921000, name: "松山镇", level: 4 },
	{ code: 450921110, parentCode: 450921000, name: "罗江镇", level: 4 },
	{ code: 450921111, parentCode: 450921000, name: "石头镇", level: 4 },
	{ code: 450921112, parentCode: 450921000, name: "石寨镇", level: 4 },
	{ code: 450921113, parentCode: 450921000, name: "十里镇", level: 4 },
	{ code: 450921114, parentCode: 450921000, name: "容西镇", level: 4 },
	{ code: 450921115, parentCode: 450921000, name: "浪水镇", level: 4 },
	{ code: 450922101, parentCode: 450922000, name: "温泉镇", level: 4 },
	{ code: 450922102, parentCode: 450922000, name: "米场镇", level: 4 },
	{ code: 450922103, parentCode: 450922000, name: "马坡镇", level: 4 },
	{ code: 450922104, parentCode: 450922000, name: "珊罗镇", level: 4 },
	{ code: 450922105, parentCode: 450922000, name: "平乐镇", level: 4 },
	{ code: 450922106, parentCode: 450922000, name: "沙坡镇", level: 4 },
	{ code: 450922107, parentCode: 450922000, name: "大桥镇", level: 4 },
	{ code: 450922108, parentCode: 450922000, name: "乌石镇", level: 4 },
	{ code: 450922109, parentCode: 450922000, name: "良田镇", level: 4 },
	{ code: 450922110, parentCode: 450922000, name: "清湖镇", level: 4 },
	{ code: 450922111, parentCode: 450922000, name: "古城镇", level: 4 },
	{ code: 450922112, parentCode: 450922000, name: "横山镇", level: 4 },
	{ code: 450922113, parentCode: 450922000, name: "滩面镇", level: 4 },
	{ code: 450922114, parentCode: 450922000, name: "沙湖镇", level: 4 },
	{ code: 450923100, parentCode: 450923000, name: "博白镇", level: 4 },
	{ code: 450923101, parentCode: 450923000, name: "径口镇", level: 4 },
	{ code: 450923102, parentCode: 450923000, name: "双凤镇", level: 4 },
	{ code: 450923105, parentCode: 450923000, name: "顿谷镇", level: 4 },
	{ code: 450923106, parentCode: 450923000, name: "水鸣镇", level: 4 },
	{ code: 450923107, parentCode: 450923000, name: "那林镇", level: 4 },
	{ code: 450923108, parentCode: 450923000, name: "江宁镇", level: 4 },
	{ code: 450923109, parentCode: 450923000, name: "三滩镇", level: 4 },
	{ code: 450923110, parentCode: 450923000, name: "黄凌镇", level: 4 },
	{ code: 450923111, parentCode: 450923000, name: "亚山镇", level: 4 },
	{ code: 450923112, parentCode: 450923000, name: "旺茂镇", level: 4 },
	{ code: 450923114, parentCode: 450923000, name: "东平镇", level: 4 },
	{ code: 450923115, parentCode: 450923000, name: "沙河镇", level: 4 },
	{ code: 450923116, parentCode: 450923000, name: "菱角镇", level: 4 },
	{ code: 450923117, parentCode: 450923000, name: "新田镇", level: 4 },
	{ code: 450923118, parentCode: 450923000, name: "凤山镇", level: 4 },
	{ code: 450923119, parentCode: 450923000, name: "宁潭镇", level: 4 },
	{ code: 450923120, parentCode: 450923000, name: "文地镇", level: 4 },
	{ code: 450923121, parentCode: 450923000, name: "英桥镇", level: 4 },
	{ code: 450923122, parentCode: 450923000, name: "那卜镇", level: 4 },
	{ code: 450923123, parentCode: 450923000, name: "大垌镇", level: 4 },
	{ code: 450923124, parentCode: 450923000, name: "沙陂镇", level: 4 },
	{ code: 450923125, parentCode: 450923000, name: "双旺镇", level: 4 },
	{ code: 450923126, parentCode: 450923000, name: "松旺镇", level: 4 },
	{ code: 450923127, parentCode: 450923000, name: "龙潭镇", level: 4 },
	{ code: 450923128, parentCode: 450923000, name: "大坝镇", level: 4 },
	{ code: 450923129, parentCode: 450923000, name: "永安镇", level: 4 },
	{ code: 450923130, parentCode: 450923000, name: "浪平镇", level: 4 },
	{ code: 450924100, parentCode: 450924000, name: "石南镇", level: 4 },
	{ code: 450924101, parentCode: 450924000, name: "大平山镇", level: 4 },
	{ code: 450924102, parentCode: 450924000, name: "葵阳镇", level: 4 },
	{ code: 450924103, parentCode: 450924000, name: "城隍镇", level: 4 },
	{ code: 450924104, parentCode: 450924000, name: "山心镇", level: 4 },
	{ code: 450924105, parentCode: 450924000, name: "沙塘镇", level: 4 },
	{ code: 450924106, parentCode: 450924000, name: "蒲塘镇", level: 4 },
	{ code: 450924107, parentCode: 450924000, name: "北市镇", level: 4 },
	{ code: 450924108, parentCode: 450924000, name: "龙安镇", level: 4 },
	{ code: 450924109, parentCode: 450924000, name: "高峰镇", level: 4 },
	{ code: 450924110, parentCode: 450924000, name: "小平山镇", level: 4 },
	{ code: 450924111, parentCode: 450924000, name: "卖酒镇", level: 4 },
	{ code: 450924124, parentCode: 450924000, name: "洛阳镇", level: 4 },
	{ code: 450981001, parentCode: 450981000, name: "陵城街道", level: 4 },
	{ code: 450981002, parentCode: 450981000, name: "城南街道", level: 4 },
	{ code: 450981003, parentCode: 450981000, name: "城北街道", level: 4 },
	{ code: 450981100, parentCode: 450981000, name: "北流镇", level: 4 },
	{ code: 450981101, parentCode: 450981000, name: "新荣镇", level: 4 },
	{ code: 450981102, parentCode: 450981000, name: "民安镇", level: 4 },
	{ code: 450981103, parentCode: 450981000, name: "山围镇", level: 4 },
	{ code: 450981104, parentCode: 450981000, name: "民乐镇", level: 4 },
	{ code: 450981105, parentCode: 450981000, name: "西埌镇", level: 4 },
	{ code: 450981106, parentCode: 450981000, name: "新圩镇", level: 4 },
	{ code: 450981107, parentCode: 450981000, name: "大里镇", level: 4 },
	{ code: 450981108, parentCode: 450981000, name: "塘岸镇", level: 4 },
	{ code: 450981109, parentCode: 450981000, name: "清水口镇", level: 4 },
	{ code: 450981110, parentCode: 450981000, name: "隆盛镇", level: 4 },
	{ code: 450981111, parentCode: 450981000, name: "大坡外镇", level: 4 },
	{ code: 450981112, parentCode: 450981000, name: "六麻镇", level: 4 },
	{ code: 450981113, parentCode: 450981000, name: "新丰镇", level: 4 },
	{ code: 450981114, parentCode: 450981000, name: "沙垌镇", level: 4 },
	{ code: 450981115, parentCode: 450981000, name: "平政镇", level: 4 },
	{ code: 450981116, parentCode: 450981000, name: "白马镇", level: 4 },
	{ code: 450981117, parentCode: 450981000, name: "大伦镇", level: 4 },
	{ code: 450981118, parentCode: 450981000, name: "扶新镇", level: 4 },
	{ code: 450981119, parentCode: 450981000, name: "六靖镇", level: 4 },
	{ code: 450981120, parentCode: 450981000, name: "石窝镇", level: 4 },
	{ code: 450981122, parentCode: 450981000, name: "清湾镇", level: 4 },
	{ code: 451002001, parentCode: 451002000, name: "百城街道", level: 4 },
	{ code: 451002002, parentCode: 451002000, name: "龙景街道", level: 4 },
	{ code: 451002101, parentCode: 451002000, name: "阳圩镇", level: 4 },
	{ code: 451002102, parentCode: 451002000, name: "四塘镇", level: 4 },
	{ code: 451002103, parentCode: 451002000, name: "龙川镇", level: 4 },
	{ code: 451002104, parentCode: 451002000, name: "永乐镇", level: 4 },
	{ code: 451002202, parentCode: 451002000, name: "汪甸瑶族乡", level: 4 },
	{ code: 451002204, parentCode: 451002000, name: "大楞乡", level: 4 },
	{ code: 451002206, parentCode: 451002000, name: "泮水乡", level: 4 },
	{ code: 451003100, parentCode: 451003000, name: "田州镇", level: 4 },
	{ code: 451003101, parentCode: 451003000, name: "那坡镇", level: 4 },
	{ code: 451003102, parentCode: 451003000, name: "坡洪镇", level: 4 },
	{ code: 451003103, parentCode: 451003000, name: "那满镇", level: 4 },
	{ code: 451003104, parentCode: 451003000, name: "百育镇", level: 4 },
	{ code: 451003105, parentCode: 451003000, name: "玉凤镇", level: 4 },
	{ code: 451003106, parentCode: 451003000, name: "头塘镇", level: 4 },
	{ code: 451003107, parentCode: 451003000, name: "五村镇", level: 4 },
	{ code: 451003108, parentCode: 451003000, name: "洞靖镇", level: 4 },
	{ code: 451003204, parentCode: 451003000, name: "巴别乡", level: 4 },
	{ code: 451022100, parentCode: 451022000, name: "平马镇", level: 4 },
	{ code: 451022101, parentCode: 451022000, name: "祥周镇", level: 4 },
	{ code: 451022103, parentCode: 451022000, name: "林逢镇", level: 4 },
	{ code: 451022105, parentCode: 451022000, name: "思林镇", level: 4 },
	{ code: 451022106, parentCode: 451022000, name: "印茶镇", level: 4 },
	{ code: 451022107, parentCode: 451022000, name: "江城镇", level: 4 },
	{ code: 451022108, parentCode: 451022000, name: "朔良镇", level: 4 },
	{ code: 451022109, parentCode: 451022000, name: "义圩镇", level: 4 },
	{ code: 451022110, parentCode: 451022000, name: "那拔镇", level: 4 },
	{ code: 451022201, parentCode: 451022000, name: "作登瑶族乡", level: 4 },
	{ code: 451024100, parentCode: 451024000, name: "城关镇", level: 4 },
	{ code: 451024101, parentCode: 451024000, name: "隆桑镇", level: 4 },
	{ code: 451024102, parentCode: 451024000, name: "敬德镇", level: 4 },
	{ code: 451024103, parentCode: 451024000, name: "足荣镇", level: 4 },
	{ code: 451024122, parentCode: 451024000, name: "马隘镇", level: 4 },
	{ code: 451024123, parentCode: 451024000, name: "东凌镇", level: 4 },
	{ code: 451024124, parentCode: 451024000, name: "那甲镇", level: 4 },
	{ code: 451024201, parentCode: 451024000, name: "都安乡", level: 4 },
	{ code: 451024205, parentCode: 451024000, name: "荣华乡", level: 4 },
	{ code: 451024207, parentCode: 451024000, name: "燕峒乡", level: 4 },
	{ code: 451024208, parentCode: 451024000, name: "龙光乡", level: 4 },
	{ code: 451024210, parentCode: 451024000, name: "巴头乡", level: 4 },
	{ code: 451026100, parentCode: 451026000, name: "城厢镇", level: 4 },
	{ code: 451026101, parentCode: 451026000, name: "平孟镇", level: 4 },
	{ code: 451026102, parentCode: 451026000, name: "龙合镇", level: 4 },
	{ code: 451026200, parentCode: 451026000, name: "坡荷乡", level: 4 },
	{ code: 451026203, parentCode: 451026000, name: "德隆乡", level: 4 },
	{ code: 451026204, parentCode: 451026000, name: "百合乡", level: 4 },
	{ code: 451026205, parentCode: 451026000, name: "百南乡", level: 4 },
	{ code: 451026207, parentCode: 451026000, name: "百省乡", level: 4 },
	{ code: 451026208, parentCode: 451026000, name: "百都乡", level: 4 },
	{ code: 451027100, parentCode: 451027000, name: "泗城镇", level: 4 },
	{ code: 451027101, parentCode: 451027000, name: "逻楼镇", level: 4 },
	{ code: 451027102, parentCode: 451027000, name: "加尤镇", level: 4 },
	{ code: 451027103, parentCode: 451027000, name: "下甲镇", level: 4 },
	{ code: 451027201, parentCode: 451027000, name: "伶站瑶族乡", level: 4 },
	{ code: 451027202, parentCode: 451027000, name: "朝里瑶族乡", level: 4 },
	{ code: 451027203, parentCode: 451027000, name: "沙里瑶族乡", level: 4 },
	{ code: 451027205, parentCode: 451027000, name: "玉洪瑶族乡", level: 4 },
	{ code: 451028100, parentCode: 451028000, name: "同乐镇", level: 4 },
	{ code: 451028101, parentCode: 451028000, name: "甘田镇", level: 4 },
	{ code: 451028102, parentCode: 451028000, name: "新化镇", level: 4 },
	{ code: 451028103, parentCode: 451028000, name: "花坪镇", level: 4 },
	{ code: 451028201, parentCode: 451028000, name: "逻沙乡", level: 4 },
	{ code: 451028203, parentCode: 451028000, name: "逻西乡", level: 4 },
	{ code: 451028204, parentCode: 451028000, name: "幼平乡", level: 4 },
	{ code: 451028205, parentCode: 451028000, name: "雅长乡", level: 4 },
	{ code: 451029100, parentCode: 451029000, name: "乐里镇", level: 4 },
	{ code: 451029101, parentCode: 451029000, name: "旧州镇", level: 4 },
	{ code: 451029102, parentCode: 451029000, name: "定安镇", level: 4 },
	{ code: 451029103, parentCode: 451029000, name: "六隆镇", level: 4 },
	{ code: 451029104, parentCode: 451029000, name: "浪平镇", level: 4 },
	{ code: 451029200, parentCode: 451029000, name: "潞城瑶族乡", level: 4 },
	{ code: 451029202, parentCode: 451029000, name: "利周瑶族乡", level: 4 },
	{ code: 451029203, parentCode: 451029000, name: "平塘乡", level: 4 },
	{ code: 451029206, parentCode: 451029000, name: "八桂瑶族乡", level: 4 },
	{ code: 451029208, parentCode: 451029000, name: "八渡瑶族乡", level: 4 },
	{ code: 451029210, parentCode: 451029000, name: "那比乡", level: 4 },
	{ code: 451029211, parentCode: 451029000, name: "高龙乡", level: 4 },
	{ code: 451029213, parentCode: 451029000, name: "百乐乡", level: 4 },
	{ code: 451029215, parentCode: 451029000, name: "者苗乡", level: 4 },
	{ code: 451030100, parentCode: 451030000, name: "八达镇", level: 4 },
	{ code: 451030101, parentCode: 451030000, name: "古障镇", level: 4 },
	{ code: 451030102, parentCode: 451030000, name: "那劳镇", level: 4 },
	{ code: 451030103, parentCode: 451030000, name: "马蚌镇", level: 4 },
	{ code: 451030203, parentCode: 451030000, name: "普合苗族乡", level: 4 },
	{ code: 451030204, parentCode: 451030000, name: "西平乡", level: 4 },
	{ code: 451030206, parentCode: 451030000, name: "那佐苗族乡", level: 4 },
	{ code: 451030208, parentCode: 451030000, name: "足别瑶族苗族乡", level: 4 },
	{ code: 451031100, parentCode: 451031000, name: "新州镇", level: 4 },
	{ code: 451031101, parentCode: 451031000, name: "桠杈镇", level: 4 },
	{ code: 451031102, parentCode: 451031000, name: "天生桥镇", level: 4 },
	{ code: 451031103, parentCode: 451031000, name: "平班镇", level: 4 },
	{ code: 451031104, parentCode: 451031000, name: "德峨镇", level: 4 },
	{ code: 451031105, parentCode: 451031000, name: "隆或镇", level: 4 },
	{ code: 451031200, parentCode: 451031000, name: "沙梨乡", level: 4 },
	{ code: 451031203, parentCode: 451031000, name: "者保乡", level: 4 },
	{ code: 451031204, parentCode: 451031000, name: "者浪乡", level: 4 },
	{ code: 451031205, parentCode: 451031000, name: "革步乡", level: 4 },
	{ code: 451031206, parentCode: 451031000, name: "金钟山乡", level: 4 },
	{ code: 451031208, parentCode: 451031000, name: "猪场乡", level: 4 },
	{ code: 451031210, parentCode: 451031000, name: "蛇场乡", level: 4 },
	{ code: 451031211, parentCode: 451031000, name: "克长乡", level: 4 },
	{ code: 451031213, parentCode: 451031000, name: "岩茶乡", level: 4 },
	{ code: 451031215, parentCode: 451031000, name: "介廷乡", level: 4 },
	{ code: 451081100, parentCode: 451081000, name: "新靖镇", level: 4 },
	{ code: 451081101, parentCode: 451081000, name: "化峒镇", level: 4 },
	{ code: 451081102, parentCode: 451081000, name: "湖润镇", level: 4 },
	{ code: 451081103, parentCode: 451081000, name: "安德镇", level: 4 },
	{ code: 451081104, parentCode: 451081000, name: "龙临镇", level: 4 },
	{ code: 451081105, parentCode: 451081000, name: "渠洋镇", level: 4 },
	{ code: 451081106, parentCode: 451081000, name: "岳圩镇", level: 4 },
	{ code: 451081107, parentCode: 451081000, name: "龙邦镇", level: 4 },
	{ code: 451081108, parentCode: 451081000, name: "武平镇", level: 4 },
	{ code: 451081109, parentCode: 451081000, name: "禄峒镇", level: 4 },
	{ code: 451081110, parentCode: 451081000, name: "地州镇", level: 4 },
	{ code: 451081200, parentCode: 451081000, name: "同德乡", level: 4 },
	{ code: 451081201, parentCode: 451081000, name: "壬庄乡", level: 4 },
	{ code: 451081202, parentCode: 451081000, name: "安宁乡", level: 4 },
	{ code: 451081206, parentCode: 451081000, name: "南坡乡", level: 4 },
	{ code: 451081207, parentCode: 451081000, name: "吞盘乡", level: 4 },
	{ code: 451081209, parentCode: 451081000, name: "果乐乡", level: 4 },
	{ code: 451081210, parentCode: 451081000, name: "新甲乡", level: 4 },
	{ code: 451081215, parentCode: 451081000, name: "魁圩乡", level: 4 },
	{ code: 451082100, parentCode: 451082000, name: "马头镇", level: 4 },
	{ code: 451082101, parentCode: 451082000, name: "新安镇", level: 4 },
	{ code: 451082102, parentCode: 451082000, name: "果化镇", level: 4 },
	{ code: 451082103, parentCode: 451082000, name: "太平镇", level: 4 },
	{ code: 451082104, parentCode: 451082000, name: "坡造镇", level: 4 },
	{ code: 451082105, parentCode: 451082000, name: "四塘镇", level: 4 },
	{ code: 451082106, parentCode: 451082000, name: "旧城镇", level: 4 },
	{ code: 451082107, parentCode: 451082000, name: "榜圩镇", level: 4 },
	{ code: 451082108, parentCode: 451082000, name: "凤梧镇", level: 4 },
	{ code: 451082202, parentCode: 451082000, name: "海城乡", level: 4 },
	{ code: 451082205, parentCode: 451082000, name: "黎明乡", level: 4 },
	{ code: 451082206, parentCode: 451082000, name: "同老乡", level: 4 },
	{ code: 451102001, parentCode: 451102000, name: "八步街道", level: 4 },
	{ code: 451102002, parentCode: 451102000, name: "城东街道", level: 4 },
	{ code: 451102003, parentCode: 451102000, name: "江南街道", level: 4 },
	{ code: 451102101, parentCode: 451102000, name: "贺街镇", level: 4 },
	{ code: 451102102, parentCode: 451102000, name: "步头镇", level: 4 },
	{ code: 451102103, parentCode: 451102000, name: "莲塘镇", level: 4 },
	{ code: 451102104, parentCode: 451102000, name: "大宁镇", level: 4 },
	{ code: 451102105, parentCode: 451102000, name: "南乡镇", level: 4 },
	{ code: 451102106, parentCode: 451102000, name: "桂岭镇", level: 4 },
	{ code: 451102107, parentCode: 451102000, name: "开山镇", level: 4 },
	{ code: 451102109, parentCode: 451102000, name: "里松镇", level: 4 },
	{ code: 451102114, parentCode: 451102000, name: "信都镇", level: 4 },
	{ code: 451102115, parentCode: 451102000, name: "灵峰镇", level: 4 },
	{ code: 451102116, parentCode: 451102000, name: "仁义镇", level: 4 },
	{ code: 451102117, parentCode: 451102000, name: "铺门镇", level: 4 },
	{ code: 451102200, parentCode: 451102000, name: "黄洞瑶族乡", level: 4 },
	{ code: 451103001, parentCode: 451103000, name: "西湾街道", level: 4 },
	{ code: 451103100, parentCode: 451103000, name: "黄田镇", level: 4 },
	{ code: 451103101, parentCode: 451103000, name: "鹅塘镇", level: 4 },
	{ code: 451103102, parentCode: 451103000, name: "沙田镇", level: 4 },
	{ code: 451103103, parentCode: 451103000, name: "公会镇", level: 4 },
	{ code: 451103104, parentCode: 451103000, name: "水口镇", level: 4 },
	{ code: 451103105, parentCode: 451103000, name: "望高镇", level: 4 },
	{ code: 451103106, parentCode: 451103000, name: "羊头镇", level: 4 },
	{ code: 451103200, parentCode: 451103000, name: "大平瑶族乡", level: 4 },
	{ code: 451121100, parentCode: 451121000, name: "昭平镇", level: 4 },
	{ code: 451121101, parentCode: 451121000, name: "文竹镇", level: 4 },
	{ code: 451121102, parentCode: 451121000, name: "黄姚镇", level: 4 },
	{ code: 451121103, parentCode: 451121000, name: "富罗镇", level: 4 },
	{ code: 451121104, parentCode: 451121000, name: "北陀镇", level: 4 },
	{ code: 451121105, parentCode: 451121000, name: "马江镇", level: 4 },
	{ code: 451121107, parentCode: 451121000, name: "五将镇", level: 4 },
	{ code: 451121108, parentCode: 451121000, name: "走马镇", level: 4 },
	{ code: 451121109, parentCode: 451121000, name: "樟木林镇", level: 4 },
	{ code: 451121201, parentCode: 451121000, name: "仙回瑶族乡", level: 4 },
	{ code: 451121206, parentCode: 451121000, name: "凤凰乡", level: 4 },
	{ code: 451121208, parentCode: 451121000, name: "木格乡", level: 4 },
	{ code: 451122100, parentCode: 451122000, name: "钟山镇", level: 4 },
	{ code: 451122105, parentCode: 451122000, name: "回龙镇", level: 4 },
	{ code: 451122106, parentCode: 451122000, name: "石龙镇", level: 4 },
	{ code: 451122107, parentCode: 451122000, name: "凤翔镇", level: 4 },
	{ code: 451122108, parentCode: 451122000, name: "珊瑚镇", level: 4 },
	{ code: 451122109, parentCode: 451122000, name: "同古镇", level: 4 },
	{ code: 451122110, parentCode: 451122000, name: "公安镇", level: 4 },
	{ code: 451122112, parentCode: 451122000, name: "清塘镇", level: 4 },
	{ code: 451122113, parentCode: 451122000, name: "燕塘镇", level: 4 },
	{ code: 451122114, parentCode: 451122000, name: "红花镇", level: 4 },
	{ code: 451122200, parentCode: 451122000, name: "花山瑶族乡", level: 4 },
	{ code: 451122201, parentCode: 451122000, name: "两安瑶族乡", level: 4 },
	{ code: 451123100, parentCode: 451123000, name: "富阳镇", level: 4 },
	{ code: 451123101, parentCode: 451123000, name: "白沙镇", level: 4 },
	{ code: 451123102, parentCode: 451123000, name: "莲山镇", level: 4 },
	{ code: 451123103, parentCode: 451123000, name: "古城镇", level: 4 },
	{ code: 451123104, parentCode: 451123000, name: "福利镇", level: 4 },
	{ code: 451123105, parentCode: 451123000, name: "麦岭镇", level: 4 },
	{ code: 451123106, parentCode: 451123000, name: "葛坡镇", level: 4 },
	{ code: 451123107, parentCode: 451123000, name: "城北镇", level: 4 },
	{ code: 451123108, parentCode: 451123000, name: "朝东镇", level: 4 },
	{ code: 451123200, parentCode: 451123000, name: "新华乡", level: 4 },
	{ code: 451123201, parentCode: 451123000, name: "石家乡", level: 4 },
	{ code: 451123203, parentCode: 451123000, name: "柳家乡", level: 4 },
	{ code: 451202001, parentCode: 451202000, name: "金城江街道", level: 4 },
	{ code: 451202101, parentCode: 451202000, name: "东江镇", level: 4 },
	{ code: 451202102, parentCode: 451202000, name: "六圩镇", level: 4 },
	{ code: 451202103, parentCode: 451202000, name: "六甲镇", level: 4 },
	{ code: 451202104, parentCode: 451202000, name: "河池镇", level: 4 },
	{ code: 451202105, parentCode: 451202000, name: "拔贡镇", level: 4 },
	{ code: 451202106, parentCode: 451202000, name: "九圩镇", level: 4 },
	{ code: 451202107, parentCode: 451202000, name: "五圩镇", level: 4 },
	{ code: 451202200, parentCode: 451202000, name: "白土乡", level: 4 },
	{ code: 451202203, parentCode: 451202000, name: "侧岭乡", level: 4 },
	{ code: 451202204, parentCode: 451202000, name: "保平乡", level: 4 },
	{ code: 451202205, parentCode: 451202000, name: "长老乡", level: 4 },
	{ code: 451203100, parentCode: 451203000, name: "庆远镇", level: 4 },
	{ code: 451203101, parentCode: 451203000, name: "三岔镇", level: 4 },
	{ code: 451203102, parentCode: 451203000, name: "洛西镇", level: 4 },
	{ code: 451203103, parentCode: 451203000, name: "怀远镇", level: 4 },
	{ code: 451203104, parentCode: 451203000, name: "德胜镇", level: 4 },
	{ code: 451203105, parentCode: 451203000, name: "石别镇", level: 4 },
	{ code: 451203106, parentCode: 451203000, name: "北山镇", level: 4 },
	{ code: 451203107, parentCode: 451203000, name: "洛东镇", level: 4 },
	{ code: 451203108, parentCode: 451203000, name: "刘三姐镇", level: 4 },
	{ code: 451203200, parentCode: 451203000, name: "祥贝乡", level: 4 },
	{ code: 451203203, parentCode: 451203000, name: "屏南乡", level: 4 },
	{ code: 451203207, parentCode: 451203000, name: "福龙瑶族乡", level: 4 },
	{ code: 451203208, parentCode: 451203000, name: "北牙瑶族乡", level: 4 },
	{ code: 451203210, parentCode: 451203000, name: "同德乡", level: 4 },
	{ code: 451203211, parentCode: 451203000, name: "安马乡", level: 4 },
	{ code: 451203213, parentCode: 451203000, name: "龙头乡", level: 4 },
	{ code: 451221100, parentCode: 451221000, name: "城关镇", level: 4 },
	{ code: 451221101, parentCode: 451221000, name: "大厂镇", level: 4 },
	{ code: 451221102, parentCode: 451221000, name: "车河镇", level: 4 },
	{ code: 451221103, parentCode: 451221000, name: "芒场镇", level: 4 },
	{ code: 451221104, parentCode: 451221000, name: "六寨镇", level: 4 },
	{ code: 451221105, parentCode: 451221000, name: "月里镇", level: 4 },
	{ code: 451221106, parentCode: 451221000, name: "吾隘镇", level: 4 },
	{ code: 451221107, parentCode: 451221000, name: "罗富镇", level: 4 },
	{ code: 451221202, parentCode: 451221000, name: "中堡苗族乡", level: 4 },
	{ code: 451221203, parentCode: 451221000, name: "八圩瑶族乡", level: 4 },
	{ code: 451221204, parentCode: 451221000, name: "里湖瑶族乡", level: 4 },
	{ code: 451222100, parentCode: 451222000, name: "六排镇", level: 4 },
	{ code: 451222101, parentCode: 451222000, name: "向阳镇", level: 4 },
	{ code: 451222200, parentCode: 451222000, name: "岜暮乡", level: 4 },
	{ code: 451222201, parentCode: 451222000, name: "八腊瑶族乡", level: 4 },
	{ code: 451222203, parentCode: 451222000, name: "纳直乡", level: 4 },
	{ code: 451222204, parentCode: 451222000, name: "更新乡", level: 4 },
	{ code: 451222206, parentCode: 451222000, name: "下老乡", level: 4 },
	{ code: 451222207, parentCode: 451222000, name: "坡结乡", level: 4 },
	{ code: 451222208, parentCode: 451222000, name: "三堡乡", level: 4 },
	{ code: 451223001, parentCode: 451223000, name: "思源街道", level: 4 },
	{ code: 451223100, parentCode: 451223000, name: "凤城镇", level: 4 },
	{ code: 451223101, parentCode: 451223000, name: "长洲镇", level: 4 },
	{ code: 451223102, parentCode: 451223000, name: "三门海镇", level: 4 },
	{ code: 451223201, parentCode: 451223000, name: "砦牙乡", level: 4 },
	{ code: 451223203, parentCode: 451223000, name: "乔音乡", level: 4 },
	{ code: 451223205, parentCode: 451223000, name: "金牙瑶族乡", level: 4 },
	{ code: 451223207, parentCode: 451223000, name: "中亭乡", level: 4 },
	{ code: 451223208, parentCode: 451223000, name: "平乐瑶族乡", level: 4 },
	{ code: 451223209, parentCode: 451223000, name: "江洲瑶族乡", level: 4 },
	{ code: 451224100, parentCode: 451224000, name: "东兰镇", level: 4 },
	{ code: 451224101, parentCode: 451224000, name: "隘洞镇", level: 4 },
	{ code: 451224102, parentCode: 451224000, name: "长乐镇", level: 4 },
	{ code: 451224103, parentCode: 451224000, name: "三石镇", level: 4 },
	{ code: 451224104, parentCode: 451224000, name: "武篆镇", level: 4 },
	{ code: 451224105, parentCode: 451224000, name: "长江镇", level: 4 },
	{ code: 451224200, parentCode: 451224000, name: "泗孟乡", level: 4 },
	{ code: 451224201, parentCode: 451224000, name: "兰木乡", level: 4 },
	{ code: 451224203, parentCode: 451224000, name: "巴畴乡", level: 4 },
	{ code: 451224204, parentCode: 451224000, name: "金谷乡", level: 4 },
	{ code: 451224205, parentCode: 451224000, name: "三弄瑶族乡", level: 4 },
	{ code: 451224206, parentCode: 451224000, name: "大同乡", level: 4 },
	{ code: 451224207, parentCode: 451224000, name: "花香乡", level: 4 },
	{ code: 451224208, parentCode: 451224000, name: "切学乡", level: 4 },
	{ code: 451225100, parentCode: 451225000, name: "东门镇", level: 4 },
	{ code: 451225101, parentCode: 451225000, name: "龙岸镇", level: 4 },
	{ code: 451225102, parentCode: 451225000, name: "黄金镇", level: 4 },
	{ code: 451225103, parentCode: 451225000, name: "小长安镇", level: 4 },
	{ code: 451225105, parentCode: 451225000, name: "四把镇", level: 4 },
	{ code: 451225106, parentCode: 451225000, name: "天河镇", level: 4 },
	{ code: 451225107, parentCode: 451225000, name: "怀群镇", level: 4 },
	{ code: 451225200, parentCode: 451225000, name: "宝坛乡", level: 4 },
	{ code: 451225202, parentCode: 451225000, name: "乔善乡", level: 4 },
	{ code: 451225203, parentCode: 451225000, name: "纳翁乡", level: 4 },
	{ code: 451225204, parentCode: 451225000, name: "兼爱乡", level: 4 },
	{ code: 451226001, parentCode: 451226000, name: "城西街道", level: 4 },
	{ code: 451226100, parentCode: 451226000, name: "思恩镇", level: 4 },
	{ code: 451226101, parentCode: 451226000, name: "水源镇", level: 4 },
	{ code: 451226102, parentCode: 451226000, name: "洛阳镇", level: 4 },
	{ code: 451226103, parentCode: 451226000, name: "川山镇", level: 4 },
	{ code: 451226104, parentCode: 451226000, name: "明伦镇", level: 4 },
	{ code: 451226105, parentCode: 451226000, name: "东兴镇", level: 4 },
	{ code: 451226200, parentCode: 451226000, name: "大才乡", level: 4 },
	{ code: 451226202, parentCode: 451226000, name: "下南乡", level: 4 },
	{ code: 451226204, parentCode: 451226000, name: "大安乡", level: 4 },
	{ code: 451226205, parentCode: 451226000, name: "长美乡", level: 4 },
	{ code: 451226206, parentCode: 451226000, name: "龙岩乡", level: 4 },
	{ code: 451226207, parentCode: 451226000, name: "驯乐苗族乡", level: 4 },
	{ code: 451227100, parentCode: 451227000, name: "巴马镇", level: 4 },
	{ code: 451227101, parentCode: 451227000, name: "甲篆镇", level: 4 },
	{ code: 451227102, parentCode: 451227000, name: "燕洞镇", level: 4 },
	{ code: 451227202, parentCode: 451227000, name: "那社乡", level: 4 },
	{ code: 451227203, parentCode: 451227000, name: "所略乡", level: 4 },
	{ code: 451227205, parentCode: 451227000, name: "西山乡", level: 4 },
	{ code: 451227207, parentCode: 451227000, name: "东山乡", level: 4 },
	{ code: 451227208, parentCode: 451227000, name: "凤凰乡", level: 4 },
	{ code: 451227209, parentCode: 451227000, name: "百林乡", level: 4 },
	{ code: 451227210, parentCode: 451227000, name: "那桃乡", level: 4 },
	{ code: 451228100, parentCode: 451228000, name: "安阳镇", level: 4 },
	{ code: 451228101, parentCode: 451228000, name: "高岭镇", level: 4 },
	{ code: 451228102, parentCode: 451228000, name: "地苏镇", level: 4 },
	{ code: 451228103, parentCode: 451228000, name: "下坳镇", level: 4 },
	{ code: 451228104, parentCode: 451228000, name: "拉烈镇", level: 4 },
	{ code: 451228105, parentCode: 451228000, name: "百旺镇", level: 4 },
	{ code: 451228106, parentCode: 451228000, name: "澄江镇", level: 4 },
	{ code: 451228107, parentCode: 451228000, name: "大兴镇", level: 4 },
	{ code: 451228108, parentCode: 451228000, name: "拉仁镇", level: 4 },
	{ code: 451228109, parentCode: 451228000, name: "永安镇", level: 4 },
	{ code: 451228204, parentCode: 451228000, name: "东庙乡", level: 4 },
	{ code: 451228208, parentCode: 451228000, name: "隆福乡", level: 4 },
	{ code: 451228209, parentCode: 451228000, name: "保安乡", level: 4 },
	{ code: 451228210, parentCode: 451228000, name: "板岭乡", level: 4 },
	{ code: 451228212, parentCode: 451228000, name: "三只羊乡", level: 4 },
	{ code: 451228213, parentCode: 451228000, name: "龙湾乡", level: 4 },
	{ code: 451228214, parentCode: 451228000, name: "菁盛乡", level: 4 },
	{ code: 451228217, parentCode: 451228000, name: "加贵乡", level: 4 },
	{ code: 451228219, parentCode: 451228000, name: "九渡乡", level: 4 },
	{ code: 451229100, parentCode: 451229000, name: "大化镇", level: 4 },
	{ code: 451229101, parentCode: 451229000, name: "都阳镇", level: 4 },
	{ code: 451229102, parentCode: 451229000, name: "岩滩镇", level: 4 },
	{ code: 451229103, parentCode: 451229000, name: "北景镇", level: 4 },
	{ code: 451229200, parentCode: 451229000, name: "共和乡", level: 4 },
	{ code: 451229201, parentCode: 451229000, name: "贡川乡", level: 4 },
	{ code: 451229202, parentCode: 451229000, name: "百马乡", level: 4 },
	{ code: 451229203, parentCode: 451229000, name: "古河乡", level: 4 },
	{ code: 451229204, parentCode: 451229000, name: "古文乡", level: 4 },
	{ code: 451229205, parentCode: 451229000, name: "江南乡", level: 4 },
	{ code: 451229206, parentCode: 451229000, name: "羌圩乡", level: 4 },
	{ code: 451229207, parentCode: 451229000, name: "乙圩乡", level: 4 },
	{ code: 451229210, parentCode: 451229000, name: "板升乡", level: 4 },
	{ code: 451229211, parentCode: 451229000, name: "七百弄乡", level: 4 },
	{ code: 451229213, parentCode: 451229000, name: "雅龙乡", level: 4 },
	{ code: 451229214, parentCode: 451229000, name: "六也乡", level: 4 },
	{ code: 451302001, parentCode: 451302000, name: "城北街道", level: 4 },
	{ code: 451302002, parentCode: 451302000, name: "城东街道", level: 4 },
	{ code: 451302003, parentCode: 451302000, name: "河西街道", level: 4 },
	{ code: 451302004, parentCode: 451302000, name: "来华街道", level: 4 },
	{ code: 451302101, parentCode: 451302000, name: "凤凰镇", level: 4 },
	{ code: 451302102, parentCode: 451302000, name: "良江镇", level: 4 },
	{ code: 451302103, parentCode: 451302000, name: "小平阳镇", level: 4 },
	{ code: 451302104, parentCode: 451302000, name: "迁江镇", level: 4 },
	{ code: 451302105, parentCode: 451302000, name: "石陵镇", level: 4 },
	{ code: 451302106, parentCode: 451302000, name: "平阳镇", level: 4 },
	{ code: 451302107, parentCode: 451302000, name: "蒙村镇", level: 4 },
	{ code: 451302108, parentCode: 451302000, name: "大湾镇", level: 4 },
	{ code: 451302109, parentCode: 451302000, name: "桥巩镇", level: 4 },
	{ code: 451302110, parentCode: 451302000, name: "寺山镇", level: 4 },
	{ code: 451302111, parentCode: 451302000, name: "城厢镇", level: 4 },
	{ code: 451302112, parentCode: 451302000, name: "三五镇", level: 4 },
	{ code: 451302113, parentCode: 451302000, name: "陶邓镇", level: 4 },
	{ code: 451302114, parentCode: 451302000, name: "石牙镇", level: 4 },
	{ code: 451302115, parentCode: 451302000, name: "五山镇", level: 4 },
	{ code: 451302116, parentCode: 451302000, name: "良塘镇", level: 4 },
	{ code: 451302206, parentCode: 451302000, name: "七洞乡", level: 4 },
	{ code: 451302213, parentCode: 451302000, name: "南泗乡", level: 4 },
	{ code: 451302214, parentCode: 451302000, name: "高安乡", level: 4 },
	{ code: 451302216, parentCode: 451302000, name: "正龙乡", level: 4 },
	{ code: 451321100, parentCode: 451321000, name: "城关镇", level: 4 },
	{ code: 451321101, parentCode: 451321000, name: "大塘镇", level: 4 },
	{ code: 451321102, parentCode: 451321000, name: "思练镇", level: 4 },
	{ code: 451321103, parentCode: 451321000, name: "红渡镇", level: 4 },
	{ code: 451321104, parentCode: 451321000, name: "古蓬镇", level: 4 },
	{ code: 451321105, parentCode: 451321000, name: "果遂镇", level: 4 },
	{ code: 451321201, parentCode: 451321000, name: "马泗乡", level: 4 },
	{ code: 451321202, parentCode: 451321000, name: "欧洞乡", level: 4 },
	{ code: 451321203, parentCode: 451321000, name: "安东乡", level: 4 },
	{ code: 451321205, parentCode: 451321000, name: "新圩乡", level: 4 },
	{ code: 451321206, parentCode: 451321000, name: "遂意乡", level: 4 },
	{ code: 451321207, parentCode: 451321000, name: "北更乡", level: 4 },
	{ code: 451322100, parentCode: 451322000, name: "象州镇", level: 4 },
	{ code: 451322101, parentCode: 451322000, name: "石龙镇", level: 4 },
	{ code: 451322102, parentCode: 451322000, name: "运江镇", level: 4 },
	{ code: 451322103, parentCode: 451322000, name: "寺村镇", level: 4 },
	{ code: 451322104, parentCode: 451322000, name: "中平镇", level: 4 },
	{ code: 451322105, parentCode: 451322000, name: "罗秀镇", level: 4 },
	{ code: 451322106, parentCode: 451322000, name: "大乐镇", level: 4 },
	{ code: 451322107, parentCode: 451322000, name: "马坪镇", level: 4 },
	{ code: 451322201, parentCode: 451322000, name: "妙皇乡", level: 4 },
	{ code: 451322202, parentCode: 451322000, name: "百丈乡", level: 4 },
	{ code: 451322203, parentCode: 451322000, name: "水晶乡", level: 4 },
	{ code: 451323100, parentCode: 451323000, name: "武宣镇", level: 4 },
	{ code: 451323101, parentCode: 451323000, name: "桐岭镇", level: 4 },
	{ code: 451323102, parentCode: 451323000, name: "通挽镇", level: 4 },
	{ code: 451323103, parentCode: 451323000, name: "东乡镇", level: 4 },
	{ code: 451323104, parentCode: 451323000, name: "三里镇", level: 4 },
	{ code: 451323105, parentCode: 451323000, name: "二塘镇", level: 4 },
	{ code: 451323106, parentCode: 451323000, name: "黄茆镇", level: 4 },
	{ code: 451323107, parentCode: 451323000, name: "禄新镇", level: 4 },
	{ code: 451323108, parentCode: 451323000, name: "思灵镇", level: 4 },
	{ code: 451323205, parentCode: 451323000, name: "金鸡乡", level: 4 },
	{ code: 451324100, parentCode: 451324000, name: "金秀镇", level: 4 },
	{ code: 451324101, parentCode: 451324000, name: "桐木镇", level: 4 },
	{ code: 451324102, parentCode: 451324000, name: "头排镇", level: 4 },
	{ code: 451324200, parentCode: 451324000, name: "三角乡", level: 4 },
	{ code: 451324201, parentCode: 451324000, name: "忠良乡", level: 4 },
	{ code: 451324202, parentCode: 451324000, name: "罗香乡", level: 4 },
	{ code: 451324203, parentCode: 451324000, name: "长垌乡", level: 4 },
	{ code: 451324204, parentCode: 451324000, name: "大樟乡", level: 4 },
	{ code: 451324205, parentCode: 451324000, name: "六巷乡", level: 4 },
	{ code: 451324207, parentCode: 451324000, name: "三江乡", level: 4 },
	{ code: 451381100, parentCode: 451381000, name: "岭南镇", level: 4 },
	{ code: 451381101, parentCode: 451381000, name: "北泗镇", level: 4 },
	{ code: 451381102, parentCode: 451381000, name: "河里镇", level: 4 },
	{ code: 451402001, parentCode: 451402000, name: "太平街道", level: 4 },
	{ code: 451402002, parentCode: 451402000, name: "江南街道", level: 4 },
	{ code: 451402003, parentCode: 451402000, name: "石景林街道", level: 4 },
	{ code: 451402101, parentCode: 451402000, name: "新和镇", level: 4 },
	{ code: 451402102, parentCode: 451402000, name: "濑湍镇", level: 4 },
	{ code: 451402103, parentCode: 451402000, name: "江州镇", level: 4 },
	{ code: 451402104, parentCode: 451402000, name: "左州镇", level: 4 },
	{ code: 451402105, parentCode: 451402000, name: "那隆镇", level: 4 },
	{ code: 451402106, parentCode: 451402000, name: "驮卢镇", level: 4 },
	{ code: 451402201, parentCode: 451402000, name: "罗白乡", level: 4 },
	{ code: 451402202, parentCode: 451402000, name: "板利乡", level: 4 },
	{ code: 451421100, parentCode: 451421000, name: "新宁镇", level: 4 },
	{ code: 451421101, parentCode: 451421000, name: "渠黎镇", level: 4 },
	{ code: 451421102, parentCode: 451421000, name: "渠旧镇", level: 4 },
	{ code: 451421103, parentCode: 451421000, name: "柳桥镇", level: 4 },
	{ code: 451421104, parentCode: 451421000, name: "东门镇", level: 4 },
	{ code: 451421105, parentCode: 451421000, name: "山圩镇", level: 4 },
	{ code: 451421106, parentCode: 451421000, name: "中东镇", level: 4 },
	{ code: 451421107, parentCode: 451421000, name: "东罗镇", level: 4 },
	{ code: 451421201, parentCode: 451421000, name: "龙头乡", level: 4 },
	{ code: 451421202, parentCode: 451421000, name: "岜盆乡", level: 4 },
	{ code: 451421203, parentCode: 451421000, name: "昌平乡", level: 4 },
	{ code: 451422100, parentCode: 451422000, name: "城中镇", level: 4 },
	{ code: 451422101, parentCode: 451422000, name: "爱店镇", level: 4 },
	{ code: 451422102, parentCode: 451422000, name: "明江镇", level: 4 },
	{ code: 451422103, parentCode: 451422000, name: "海渊镇", level: 4 },
	{ code: 451422104, parentCode: 451422000, name: "那堪镇", level: 4 },
	{ code: 451422105, parentCode: 451422000, name: "桐棉镇", level: 4 },
	{ code: 451422106, parentCode: 451422000, name: "亭亮镇", level: 4 },
	{ code: 451422202, parentCode: 451422000, name: "寨安乡", level: 4 },
	{ code: 451422203, parentCode: 451422000, name: "峙浪乡", level: 4 },
	{ code: 451422204, parentCode: 451422000, name: "东安乡", level: 4 },
	{ code: 451422205, parentCode: 451422000, name: "板棍乡", level: 4 },
	{ code: 451422206, parentCode: 451422000, name: "北江乡", level: 4 },
	{ code: 451422209, parentCode: 451422000, name: "那楠乡", level: 4 },
	{ code: 451423100, parentCode: 451423000, name: "龙州镇", level: 4 },
	{ code: 451423101, parentCode: 451423000, name: "下冻镇", level: 4 },
	{ code: 451423102, parentCode: 451423000, name: "水口镇", level: 4 },
	{ code: 451423103, parentCode: 451423000, name: "金龙镇", level: 4 },
	{ code: 451423104, parentCode: 451423000, name: "响水镇", level: 4 },
	{ code: 451423201, parentCode: 451423000, name: "八角乡", level: 4 },
	{ code: 451423202, parentCode: 451423000, name: "上降乡", level: 4 },
	{ code: 451423203, parentCode: 451423000, name: "彬桥乡", level: 4 },
	{ code: 451423204, parentCode: 451423000, name: "上龙乡", level: 4 },
	{ code: 451423205, parentCode: 451423000, name: "武德乡", level: 4 },
	{ code: 451423206, parentCode: 451423000, name: "逐卜乡", level: 4 },
	{ code: 451423207, parentCode: 451423000, name: "上金乡", level: 4 },
	{ code: 451424100, parentCode: 451424000, name: "桃城镇", level: 4 },
	{ code: 451424101, parentCode: 451424000, name: "全茗镇", level: 4 },
	{ code: 451424102, parentCode: 451424000, name: "雷平镇", level: 4 },
	{ code: 451424103, parentCode: 451424000, name: "硕龙镇", level: 4 },
	{ code: 451424104, parentCode: 451424000, name: "下雷镇", level: 4 },
	{ code: 451424200, parentCode: 451424000, name: "五山乡", level: 4 },
	{ code: 451424201, parentCode: 451424000, name: "龙门乡", level: 4 },
	{ code: 451424202, parentCode: 451424000, name: "昌明乡", level: 4 },
	{ code: 451424203, parentCode: 451424000, name: "福隆乡", level: 4 },
	{ code: 451424204, parentCode: 451424000, name: "那岭乡", level: 4 },
	{ code: 451424205, parentCode: 451424000, name: "恩城乡", level: 4 },
	{ code: 451424206, parentCode: 451424000, name: "榄圩乡", level: 4 },
	{ code: 451424207, parentCode: 451424000, name: "宝圩乡", level: 4 },
	{ code: 451424208, parentCode: 451424000, name: "堪圩乡", level: 4 },
	{ code: 451425100, parentCode: 451425000, name: "天等镇", level: 4 },
	{ code: 451425101, parentCode: 451425000, name: "龙茗镇", level: 4 },
	{ code: 451425102, parentCode: 451425000, name: "进结镇", level: 4 },
	{ code: 451425103, parentCode: 451425000, name: "向都镇", level: 4 },
	{ code: 451425104, parentCode: 451425000, name: "东平镇", level: 4 },
	{ code: 451425105, parentCode: 451425000, name: "福新镇", level: 4 },
	{ code: 451425200, parentCode: 451425000, name: "都康乡", level: 4 },
	{ code: 451425201, parentCode: 451425000, name: "宁干乡", level: 4 },
	{ code: 451425202, parentCode: 451425000, name: "驮堪乡", level: 4 },
	{ code: 451425205, parentCode: 451425000, name: "进远乡", level: 4 },
	{ code: 451425206, parentCode: 451425000, name: "上映乡", level: 4 },
	{ code: 451425207, parentCode: 451425000, name: "把荷乡", level: 4 },
	{ code: 451425208, parentCode: 451425000, name: "小山乡", level: 4 },
	{ code: 451481100, parentCode: 451481000, name: "凭祥镇", level: 4 },
	{ code: 451481101, parentCode: 451481000, name: "友谊镇", level: 4 },
	{ code: 451481102, parentCode: 451481000, name: "上石镇", level: 4 },
	{ code: 451481103, parentCode: 451481000, name: "夏石镇", level: 4 },
]
